// quranData.js
// This file contains Quran data including page numbers fetched from Al-Quran Cloud API

export const surahs = [
  'Al-Fatiha',
  'Al-Baqarah',
  "Aali 'Imran",
  'An-Nisa',
  "Al-Ma'idah",
  "Al-An'am",
  "Al-A'raf",
  'Al-Anfal',
  'At-Tawbah',
  'Yunus',
  'Hud',
  'Yusuf',
  "Ar-Ra'd",
  'Ibrahim',
  'Al-Hijr',
  'An-Nahl',
  'Al-Isra',
  'Al-Kahf',
  'Maryam',
  'Taha',
  'Al-Anbiya',
  'Al-Hajj',
  "Al-Mu'minun",
  'An-Nur',
  'Al-Furqan',
  "Ash-Shu'ara",
  'An-Naml',
  'Al-Qasas',
  'Al-Ankabut',
  'Ar-Rum',
  'Luqman',
  'As-Sajda',
  'Al-Ahzab',
  'Saba',
  'Fatir',
  'Ya-Sin',
  'As-Saffat',
  'Sad',
  'Az-Zumar',
  'Ghafir',
  'Fussilat',
  'Ash-Shura',
  'Az-Zukhruf',
  'Ad-Dukhan',
  'Al-Jathiya',
  'Al-Ahqaf',
  'Muhammad',
  'Al-Fath',
  'Al-Hujurat',
  'Qaf',
  'Adh-Dhariyat',
  'At-Tur',
  'An-Najm',
  'Al-Qamar',
  'Ar-Rahman',
  "Al-Waqi'ah",
  'Al-Hadid',
  'Al-Mujadila',
  'Al-Hashr',
  'Al-Mumtahina',
  'As-Saff',
  "Al-Jumu'ah",
  'Al-Munafiqun',
  'At-Taghabun',
  'At-Talaq',
  'At-Tahrim',
  'Al-Mulk',
  'Al-Qalam',
  'Al-Haqqah',
  "Al-Ma'arij",
  'Nuh',
  'Al-Jinn',
  'Al-Muzzammil',
  'Al-Muddathir',
  'Al-Qiyamah',
  'Al-Insan',
  'Al-Mursalat',
  'An-Naba',
  "An-Nazi'at",
  'Abasa',
  'At-Takwir',
  'Al-Infitar',
  'Al-Mutaffifin',
  'Al-Inshiqaq',
  'Al-Buruj',
  'At-Tariq',
  "Al-A'la",
  'Al-Ghashiya',
  'Al-Fajr',
  'Al-Balad',
  'Ash-Shams',
  'Al-Lail',
  'Ad-Duha',
  'Al-Inshirah',
  'At-Tin',
  'Al-Alaq',
  'Al-Qadr',
  'Al-Bayyina',
  'Az-Zalzalah',
  'Al-Adiyat',
  "Al-Qari'a",
  'At-Takathur',
  'Al-Asr',
  'Al-Humazah',
  'Al-Fil',
  'Quraish',
  "Al-Ma'un",
  'Al-Kawthar',
  'Al-Kafirun',
  'An-Nasr',
  'Al-Masad',
  'Al-Ikhlas',
  'Al-Falaq',
  'An-Nas',
]

export const surahVerses = {
  'Al-Fatiha': 7,
  'Al-Baqarah': 286,
  "Aali 'Imran": 200,
  'An-Nisa': 176,
  "Al-Ma'idah": 120,
  "Al-An'am": 165,
  "Al-A'raf": 206,
  'Al-Anfal': 75,
  'At-Tawbah': 129,
  'Yunus': 109,
  'Hud': 123,
  'Yusuf': 111,
  "Ar-Ra'd": 43,
  'Ibrahim': 52,
  'Al-Hijr': 99,
  'An-Nahl': 128,
  'Al-Isra': 111,
  'Al-Kahf': 110,
  'Maryam': 98,
  'Taha': 135,
  'Al-Anbiya': 112,
  'Al-Hajj': 78,
  "Al-Mu'minun": 118,
  'An-Nur': 64,
  'Al-Furqan': 77,
  "Ash-Shu'ara": 227,
  'An-Naml': 93,
  'Al-Qasas': 88,
  'Al-Ankabut': 69,
  'Ar-Rum': 60,
  'Luqman': 34,
  'As-Sajda': 30,
  'Al-Ahzab': 73,
  'Saba': 54,
  'Fatir': 45,
  'Ya-Sin': 83,
  'As-Saffat': 182,
  'Sad': 88,
  'Az-Zumar': 75,
  'Ghafir': 85,
  'Fussilat': 54,
  'Ash-Shura': 53,
  'Az-Zukhruf': 89,
  'Ad-Dukhan': 59,
  'Al-Jathiya': 37,
  'Al-Ahqaf': 35,
  'Muhammad': 38,
  'Al-Fath': 29,
  'Al-Hujurat': 18,
  'Qaf': 45,
  'Adh-Dhariyat': 60,
  'At-Tur': 49,
  'An-Najm': 62,
  'Al-Qamar': 55,
  'Ar-Rahman': 78,
  "Al-Waqi'ah": 96,
  'Al-Hadid': 29,
  'Al-Mujadila': 22,
  'Al-Hashr': 24,
  'Al-Mumtahina': 13,
  'As-Saff': 14,
  "Al-Jumu'ah": 11,
  'Al-Munafiqun': 11,
  'At-Taghabun': 18,
  'At-Talaq': 12,
  'At-Tahrim': 12,
  'Al-Mulk': 30,
  'Al-Qalam': 52,
  'Al-Haqqah': 52,
  "Al-Ma'arij": 44,
  'Nuh': 28,
  'Al-Jinn': 28,
  'Al-Muzzammil': 20,
  'Al-Muddathir': 56,
  'Al-Qiyamah': 40,
  'Al-Insan': 31,
  'Al-Mursalat': 50,
  'An-Naba': 40,
  "An-Nazi'at": 46,
  'Abasa': 42,
  'At-Takwir': 29,
  'Al-Infitar': 19,
  'Al-Mutaffifin': 36,
  'Al-Inshiqaq': 25,
  'Al-Buruj': 22,
  'At-Tariq': 17,
  "Al-A'la": 19,
  'Al-Ghashiya': 26,
  'Al-Fajr': 30,
  'Al-Balad': 20,
  'Ash-Shams': 15,
  'Al-Lail': 21,
  'Ad-Duha': 11,
  'Al-Inshirah': 8,
  'At-Tin': 8,
  'Al-Alaq': 19,
  'Al-Qadr': 5,
  'Al-Bayyina': 8,
  'Az-Zalzalah': 8,
  'Al-Adiyat': 11,
  "Al-Qari'a": 11,
  'At-Takathur': 8,
  'Al-Asr': 3,
  'Al-Humazah': 9,
  'Al-Fil': 5,
  'Quraish': 4,
  "Al-Ma'un": 7,
  'Al-Kawthar': 3,
  'Al-Kafirun': 6,
  'An-Nasr': 3,
  'Al-Masad': 5,
  'Al-Ikhlas': 4,
  'Al-Falaq': 5,
  'An-Nas': 6,
}

export const ayahPageNumbers = {
  "1:1": 1,
  "1:2": 1,
  "1:3": 1,
  "1:4": 1,
  "1:5": 1,
  "1:6": 1,
  "1:7": 1,
  "2:1": 2,
  "2:2": 2,
  "2:3": 2,
  "2:4": 2,
  "2:5": 2,
  "2:6": 3,
  "2:7": 3,
  "2:8": 3,
  "2:9": 3,
  "2:10": 3,
  "2:11": 3,
  "2:12": 3,
  "2:13": 3,
  "2:14": 3,
  "2:15": 3,
  "2:16": 3,
  "2:17": 4,
  "2:18": 4,
  "2:19": 4,
  "2:20": 4,
  "2:21": 4,
  "2:22": 4,
  "2:23": 4,
  "2:24": 4,
  "2:25": 5,
  "2:26": 5,
  "2:27": 5,
  "2:28": 5,
  "2:29": 5,
  "2:30": 6,
  "2:31": 6,
  "2:32": 6,
  "2:33": 6,
  "2:34": 6,
  "2:35": 6,
  "2:36": 6,
  "2:37": 6,
  "2:38": 7,
  "2:39": 7,
  "2:40": 7,
  "2:41": 7,
  "2:42": 7,
  "2:43": 7,
  "2:44": 7,
  "2:45": 7,
  "2:46": 7,
  "2:47": 7,
  "2:48": 7,
  "2:49": 8,
  "2:50": 8,
  "2:51": 8,
  "2:52": 8,
  "2:53": 8,
  "2:54": 8,
  "2:55": 8,
  "2:56": 8,
  "2:57": 8,
  "2:58": 9,
  "2:59": 9,
  "2:60": 9,
  "2:61": 9,
  "2:62": 10,
  "2:63": 10,
  "2:64": 10,
  "2:65": 10,
  "2:66": 10,
  "2:67": 10,
  "2:68": 10,
  "2:69": 10,
  "2:70": 11,
  "2:71": 11,
  "2:72": 11,
  "2:73": 11,
  "2:74": 11,
  "2:75": 11,
  "2:76": 11,
  "2:77": 12,
  "2:78": 12,
  "2:79": 12,
  "2:80": 12,
  "2:81": 12,
  "2:82": 12,
  "2:83": 12,
  "2:84": 13,
  "2:85": 13,
  "2:86": 13,
  "2:87": 13,
  "2:88": 13,
  "2:89": 14,
  "2:90": 14,
  "2:91": 14,
  "2:92": 14,
  "2:93": 14,
  "2:94": 15,
  "2:95": 15,
  "2:96": 15,
  "2:97": 15,
  "2:98": 15,
  "2:99": 15,
  "2:100": 15,
  "2:101": 15,
  "2:102": 16,
  "2:103": 16,
  "2:104": 16,
  "2:105": 16,
  "2:106": 17,
  "2:107": 17,
  "2:108": 17,
  "2:109": 17,
  "2:110": 17,
  "2:111": 17,
  "2:112": 17,
  "2:113": 18,
  "2:114": 18,
  "2:115": 18,
  "2:116": 18,
  "2:117": 18,
  "2:118": 18,
  "2:119": 18,
  "2:120": 19,
  "2:121": 19,
  "2:122": 19,
  "2:123": 19,
  "2:124": 19,
  "2:125": 19,
  "2:126": 19,
  "2:127": 20,
  "2:128": 20,
  "2:129": 20,
  "2:130": 20,
  "2:131": 20,
  "2:132": 20,
  "2:133": 20,
  "2:134": 20,
  "2:135": 21,
  "2:136": 21,
  "2:137": 21,
  "2:138": 21,
  "2:139": 21,
  "2:140": 21,
  "2:141": 21,
  "2:142": 22,
  "2:143": 22,
  "2:144": 22,
  "2:145": 22,
  "2:146": 23,
  "2:147": 23,
  "2:148": 23,
  "2:149": 23,
  "2:150": 23,
  "2:151": 23,
  "2:152": 23,
  "2:153": 23,
  "2:154": 24,
  "2:155": 24,
  "2:156": 24,
  "2:157": 24,
  "2:158": 24,
  "2:159": 24,
  "2:160": 24,
  "2:161": 24,
  "2:162": 24,
  "2:163": 24,
  "2:164": 25,
  "2:165": 25,
  "2:166": 25,
  "2:167": 25,
  "2:168": 25,
  "2:169": 25,
  "2:170": 26,
  "2:171": 26,
  "2:172": 26,
  "2:173": 26,
  "2:174": 26,
  "2:175": 26,
  "2:176": 26,
  "2:177": 27,
  "2:178": 27,
  "2:179": 27,
  "2:180": 27,
  "2:181": 27,
  "2:182": 28,
  "2:183": 28,
  "2:184": 28,
  "2:185": 28,
  "2:186": 28,
  "2:187": 29,
  "2:188": 29,
  "2:189": 29,
  "2:190": 29,
  "2:191": 30,
  "2:192": 30,
  "2:193": 30,
  "2:194": 30,
  "2:195": 30,
  "2:196": 30,
  "2:197": 31,
  "2:198": 31,
  "2:199": 31,
  "2:200": 31,
  "2:201": 31,
  "2:202": 31,
  "2:203": 32,
  "2:204": 32,
  "2:205": 32,
  "2:206": 32,
  "2:207": 32,
  "2:208": 32,
  "2:209": 32,
  "2:210": 32,
  "2:211": 33,
  "2:212": 33,
  "2:213": 33,
  "2:214": 33,
  "2:215": 33,
  "2:216": 34,
  "2:217": 34,
  "2:218": 34,
  "2:219": 34,
  "2:220": 35,
  "2:221": 35,
  "2:222": 35,
  "2:223": 35,
  "2:224": 35,
  "2:225": 36,
  "2:226": 36,
  "2:227": 36,
  "2:228": 36,
  "2:229": 36,
  "2:230": 36,
  "2:231": 37,
  "2:232": 37,
  "2:233": 37,
  "2:234": 38,
  "2:235": 38,
  "2:236": 38,
  "2:237": 38,
  "2:238": 39,
  "2:239": 39,
  "2:240": 39,
  "2:241": 39,
  "2:242": 39,
  "2:243": 39,
  "2:244": 39,
  "2:245": 39,
  "2:246": 40,
  "2:247": 40,
  "2:248": 40,
  "2:249": 41,
  "2:250": 41,
  "2:251": 41,
  "2:252": 41,
  "2:253": 42,
  "2:254": 42,
  "2:255": 42,
  "2:256": 42,
  "2:257": 43,
  "2:258": 43,
  "2:259": 43,
  "2:260": 44,
  "2:261": 44,
  "2:262": 44,
  "2:263": 44,
  "2:264": 44,
  "2:265": 45,
  "2:266": 45,
  "2:267": 45,
  "2:268": 45,
  "2:269": 45,
  "2:270": 46,
  "2:271": 46,
  "2:272": 46,
  "2:273": 46,
  "2:274": 46,
  "2:275": 47,
  "2:276": 47,
  "2:277": 47,
  "2:278": 47,
  "2:279": 47,
  "2:280": 47,
  "2:281": 47,
  "2:282": 48,
  "2:283": 49,
  "2:284": 49,
  "2:285": 49,
  "2:286": 49,
  "3:1": 50,
  "3:2": 50,
  "3:3": 50,
  "3:4": 50,
  "3:5": 50,
  "3:6": 50,
  "3:7": 50,
  "3:8": 50,
  "3:9": 50,
  "3:10": 51,
  "3:11": 51,
  "3:12": 51,
  "3:13": 51,
  "3:14": 51,
  "3:15": 51,
  "3:16": 52,
  "3:17": 52,
  "3:18": 52,
  "3:19": 52,
  "3:20": 52,
  "3:21": 52,
  "3:22": 52,
  "3:23": 53,
  "3:24": 53,
  "3:25": 53,
  "3:26": 53,
  "3:27": 53,
  "3:28": 53,
  "3:29": 53,
  "3:30": 54,
  "3:31": 54,
  "3:32": 54,
  "3:33": 54,
  "3:34": 54,
  "3:35": 54,
  "3:36": 54,
  "3:37": 54,
  "3:38": 55,
  "3:39": 55,
  "3:40": 55,
  "3:41": 55,
  "3:42": 55,
  "3:43": 55,
  "3:44": 55,
  "3:45": 55,
  "3:46": 56,
  "3:47": 56,
  "3:48": 56,
  "3:49": 56,
  "3:50": 56,
  "3:51": 56,
  "3:52": 56,
  "3:53": 57,
  "3:54": 57,
  "3:55": 57,
  "3:56": 57,
  "3:57": 57,
  "3:58": 57,
  "3:59": 57,
  "3:60": 57,
  "3:61": 57,
  "3:62": 58,
  "3:63": 58,
  "3:64": 58,
  "3:65": 58,
  "3:66": 58,
  "3:67": 58,
  "3:68": 58,
  "3:69": 58,
  "3:70": 58,
  "3:71": 59,
  "3:72": 59,
  "3:73": 59,
  "3:74": 59,
  "3:75": 59,
  "3:76": 59,
  "3:77": 59,
  "3:78": 60,
  "3:79": 60,
  "3:80": 60,
  "3:81": 60,
  "3:82": 60,
  "3:83": 60,
  "3:84": 61,
  "3:85": 61,
  "3:86": 61,
  "3:87": 61,
  "3:88": 61,
  "3:89": 61,
  "3:90": 61,
  "3:91": 61,
  "3:92": 62,
  "3:93": 62,
  "3:94": 62,
  "3:95": 62,
  "3:96": 62,
  "3:97": 62,
  "3:98": 62,
  "3:99": 62,
  "3:100": 62,
  "3:101": 63,
  "3:102": 63,
  "3:103": 63,
  "3:104": 63,
  "3:105": 63,
  "3:106": 63,
  "3:107": 63,
  "3:108": 63,
  "3:109": 64,
  "3:110": 64,
  "3:111": 64,
  "3:112": 64,
  "3:113": 64,
  "3:114": 64,
  "3:115": 64,
  "3:116": 65,
  "3:117": 65,
  "3:118": 65,
  "3:119": 65,
  "3:120": 65,
  "3:121": 65,
  "3:122": 66,
  "3:123": 66,
  "3:124": 66,
  "3:125": 66,
  "3:126": 66,
  "3:127": 66,
  "3:128": 66,
  "3:129": 66,
  "3:130": 66,
  "3:131": 66,
  "3:132": 66,
  "3:133": 67,
  "3:134": 67,
  "3:135": 67,
  "3:136": 67,
  "3:137": 67,
  "3:138": 67,
  "3:139": 67,
  "3:140": 67,
  "3:141": 68,
  "3:142": 68,
  "3:143": 68,
  "3:144": 68,
  "3:145": 68,
  "3:146": 68,
  "3:147": 68,
  "3:148": 68,
  "3:149": 69,
  "3:150": 69,
  "3:151": 69,
  "3:152": 69,
  "3:153": 69,
  "3:154": 70,
  "3:155": 70,
  "3:156": 70,
  "3:157": 70,
  "3:158": 71,
  "3:159": 71,
  "3:160": 71,
  "3:161": 71,
  "3:162": 71,
  "3:163": 71,
  "3:164": 71,
  "3:165": 71,
  "3:166": 72,
  "3:167": 72,
  "3:168": 72,
  "3:169": 72,
  "3:170": 72,
  "3:171": 72,
  "3:172": 72,
  "3:173": 72,
  "3:174": 73,
  "3:175": 73,
  "3:176": 73,
  "3:177": 73,
  "3:178": 73,
  "3:179": 73,
  "3:180": 73,
  "3:181": 74,
  "3:182": 74,
  "3:183": 74,
  "3:184": 74,
  "3:185": 74,
  "3:186": 74,
  "3:187": 75,
  "3:188": 75,
  "3:189": 75,
  "3:190": 75,
  "3:191": 75,
  "3:192": 75,
  "3:193": 75,
  "3:194": 75,
  "3:195": 76,
  "3:196": 76,
  "3:197": 76,
  "3:198": 76,
  "3:199": 76,
  "3:200": 76,
  "4:1": 77,
  "4:2": 77,
  "4:3": 77,
  "4:4": 77,
  "4:5": 77,
  "4:6": 77,
  "4:7": 78,
  "4:8": 78,
  "4:9": 78,
  "4:10": 78,
  "4:11": 78,
  "4:12": 79,
  "4:13": 79,
  "4:14": 79,
  "4:15": 80,
  "4:16": 80,
  "4:17": 80,
  "4:18": 80,
  "4:19": 80,
  "4:20": 81,
  "4:21": 81,
  "4:22": 81,
  "4:23": 81,
  "4:24": 82,
  "4:25": 82,
  "4:26": 82,
  "4:27": 83,
  "4:28": 83,
  "4:29": 83,
  "4:30": 83,
  "4:31": 83,
  "4:32": 83,
  "4:33": 83,
  "4:34": 84,
  "4:35": 84,
  "4:36": 84,
  "4:37": 84,
  "4:38": 85,
  "4:39": 85,
  "4:40": 85,
  "4:41": 85,
  "4:42": 85,
  "4:43": 85,
  "4:44": 85,
  "4:45": 86,
  "4:46": 86,
  "4:47": 86,
  "4:48": 86,
  "4:49": 86,
  "4:50": 86,
  "4:51": 86,
  "4:52": 87,
  "4:53": 87,
  "4:54": 87,
  "4:55": 87,
  "4:56": 87,
  "4:57": 87,
  "4:58": 87,
  "4:59": 87,
  "4:60": 88,
  "4:61": 88,
  "4:62": 88,
  "4:63": 88,
  "4:64": 88,
  "4:65": 88,
  "4:66": 89,
  "4:67": 89,
  "4:68": 89,
  "4:69": 89,
  "4:70": 89,
  "4:71": 89,
  "4:72": 89,
  "4:73": 89,
  "4:74": 89,
  "4:75": 90,
  "4:76": 90,
  "4:77": 90,
  "4:78": 90,
  "4:79": 90,
  "4:80": 91,
  "4:81": 91,
  "4:82": 91,
  "4:83": 91,
  "4:84": 91,
  "4:85": 91,
  "4:86": 91,
  "4:87": 92,
  "4:88": 92,
  "4:89": 92,
  "4:90": 92,
  "4:91": 92,
  "4:92": 93,
  "4:93": 93,
  "4:94": 93,
  "4:95": 94,
  "4:96": 94,
  "4:97": 94,
  "4:98": 94,
  "4:99": 94,
  "4:100": 94,
  "4:101": 94,
  "4:102": 95,
  "4:103": 95,
  "4:104": 95,
  "4:105": 95,
  "4:106": 96,
  "4:107": 96,
  "4:108": 96,
  "4:109": 96,
  "4:110": 96,
  "4:111": 96,
  "4:112": 96,
  "4:113": 96,
  "4:114": 97,
  "4:115": 97,
  "4:116": 97,
  "4:117": 97,
  "4:118": 97,
  "4:119": 97,
  "4:120": 97,
  "4:121": 97,
  "4:122": 98,
  "4:123": 98,
  "4:124": 98,
  "4:125": 98,
  "4:126": 98,
  "4:127": 98,
  "4:128": 99,
  "4:129": 99,
  "4:130": 99,
  "4:131": 99,
  "4:132": 99,
  "4:133": 99,
  "4:134": 99,
  "4:135": 100,
  "4:136": 100,
  "4:137": 100,
  "4:138": 100,
  "4:139": 100,
  "4:140": 100,
  "4:141": 101,
  "4:142": 101,
  "4:143": 101,
  "4:144": 101,
  "4:145": 101,
  "4:146": 101,
  "4:147": 101,
  "4:148": 102,
  "4:149": 102,
  "4:150": 102,
  "4:151": 102,
  "4:152": 102,
  "4:153": 102,
  "4:154": 102,
  "4:155": 103,
  "4:156": 103,
  "4:157": 103,
  "4:158": 103,
  "4:159": 103,
  "4:160": 103,
  "4:161": 103,
  "4:162": 103,
  "4:163": 104,
  "4:164": 104,
  "4:165": 104,
  "4:166": 104,
  "4:167": 104,
  "4:168": 104,
  "4:169": 104,
  "4:170": 104,
  "4:171": 105,
  "4:172": 105,
  "4:173": 105,
  "4:174": 105,
  "4:175": 105,
  "4:176": 106,
  "5:1": 106,
  "5:2": 106,
  "5:3": 107,
  "5:4": 107,
  "5:5": 107,
  "5:6": 108,
  "5:7": 108,
  "5:8": 108,
  "5:9": 108,
  "5:10": 109,
  "5:11": 109,
  "5:12": 109,
  "5:13": 109,
  "5:14": 110,
  "5:15": 110,
  "5:16": 110,
  "5:17": 110,
  "5:18": 111,
  "5:19": 111,
  "5:20": 111,
  "5:21": 111,
  "5:22": 111,
  "5:23": 111,
  "5:24": 112,
  "5:25": 112,
  "5:26": 112,
  "5:27": 112,
  "5:28": 112,
  "5:29": 112,
  "5:30": 112,
  "5:31": 112,
  "5:32": 113,
  "5:33": 113,
  "5:34": 113,
  "5:35": 113,
  "5:36": 113,
  "5:37": 114,
  "5:38": 114,
  "5:39": 114,
  "5:40": 114,
  "5:41": 114,
  "5:42": 115,
  "5:43": 115,
  "5:44": 115,
  "5:45": 115,
  "5:46": 116,
  "5:47": 116,
  "5:48": 116,
  "5:49": 116,
  "5:50": 116,
  "5:51": 117,
  "5:52": 117,
  "5:53": 117,
  "5:54": 117,
  "5:55": 117,
  "5:56": 117,
  "5:57": 117,
  "5:58": 118,
  "5:59": 118,
  "5:60": 118,
  "5:61": 118,
  "5:62": 118,
  "5:63": 118,
  "5:64": 118,
  "5:65": 119,
  "5:66": 119,
  "5:67": 119,
  "5:68": 119,
  "5:69": 119,
  "5:70": 119,
  "5:71": 120,
  "5:72": 120,
  "5:73": 120,
  "5:74": 120,
  "5:75": 120,
  "5:76": 120,
  "5:77": 121,
  "5:78": 121,
  "5:79": 121,
  "5:80": 121,
  "5:81": 121,
  "5:82": 121,
  "5:83": 122,
  "5:84": 122,
  "5:85": 122,
  "5:86": 122,
  "5:87": 122,
  "5:88": 122,
  "5:89": 122,
  "5:90": 123,
  "5:91": 123,
  "5:92": 123,
  "5:93": 123,
  "5:94": 123,
  "5:95": 123,
  "5:96": 124,
  "5:97": 124,
  "5:98": 124,
  "5:99": 124,
  "5:100": 124,
  "5:101": 124,
  "5:102": 124,
  "5:103": 124,
  "5:104": 125,
  "5:105": 125,
  "5:106": 125,
  "5:107": 125,
  "5:108": 125,
  "5:109": 126,
  "5:110": 126,
  "5:111": 126,
  "5:112": 126,
  "5:113": 126,
  "5:114": 127,
  "5:115": 127,
  "5:116": 127,
  "5:117": 127,
  "5:118": 127,
  "5:119": 127,
  "5:120": 127,
  "6:1": 128,
  "6:2": 128,
  "6:3": 128,
  "6:4": 128,
  "6:5": 128,
  "6:6": 128,
  "6:7": 128,
  "6:8": 128,
  "6:9": 129,
  "6:10": 129,
  "6:11": 129,
  "6:12": 129,
  "6:13": 129,
  "6:14": 129,
  "6:15": 129,
  "6:16": 129,
  "6:17": 129,
  "6:18": 129,
  "6:19": 130,
  "6:20": 130,
  "6:21": 130,
  "6:22": 130,
  "6:23": 130,
  "6:24": 130,
  "6:25": 130,
  "6:26": 130,
  "6:27": 130,
  "6:28": 131,
  "6:29": 131,
  "6:30": 131,
  "6:31": 131,
  "6:32": 131,
  "6:33": 131,
  "6:34": 131,
  "6:35": 131,
  "6:36": 132,
  "6:37": 132,
  "6:38": 132,
  "6:39": 132,
  "6:40": 132,
  "6:41": 132,
  "6:42": 132,
  "6:43": 132,
  "6:44": 132,
  "6:45": 133,
  "6:46": 133,
  "6:47": 133,
  "6:48": 133,
  "6:49": 133,
  "6:50": 133,
  "6:51": 133,
  "6:52": 133,
  "6:53": 134,
  "6:54": 134,
  "6:55": 134,
  "6:56": 134,
  "6:57": 134,
  "6:58": 134,
  "6:59": 134,
  "6:60": 135,
  "6:61": 135,
  "6:62": 135,
  "6:63": 135,
  "6:64": 135,
  "6:65": 135,
  "6:66": 135,
  "6:67": 135,
  "6:68": 135,
  "6:69": 136,
  "6:70": 136,
  "6:71": 136,
  "6:72": 136,
  "6:73": 136,
  "6:74": 137,
  "6:75": 137,
  "6:76": 137,
  "6:77": 137,
  "6:78": 137,
  "6:79": 137,
  "6:80": 137,
  "6:81": 137,
  "6:82": 138,
  "6:83": 138,
  "6:84": 138,
  "6:85": 138,
  "6:86": 138,
  "6:87": 138,
  "6:88": 138,
  "6:89": 138,
  "6:90": 138,
  "6:91": 139,
  "6:92": 139,
  "6:93": 139,
  "6:94": 139,
  "6:95": 140,
  "6:96": 140,
  "6:97": 140,
  "6:98": 140,
  "6:99": 140,
  "6:100": 140,
  "6:101": 140,
  "6:102": 141,
  "6:103": 141,
  "6:104": 141,
  "6:105": 141,
  "6:106": 141,
  "6:107": 141,
  "6:108": 141,
  "6:109": 141,
  "6:110": 141,
  "6:111": 142,
  "6:112": 142,
  "6:113": 142,
  "6:114": 142,
  "6:115": 142,
  "6:116": 142,
  "6:117": 142,
  "6:118": 142,
  "6:119": 143,
  "6:120": 143,
  "6:121": 143,
  "6:122": 143,
  "6:123": 143,
  "6:124": 143,
  "6:125": 144,
  "6:126": 144,
  "6:127": 144,
  "6:128": 144,
  "6:129": 144,
  "6:130": 144,
  "6:131": 144,
  "6:132": 145,
  "6:133": 145,
  "6:134": 145,
  "6:135": 145,
  "6:136": 145,
  "6:137": 145,
  "6:138": 146,
  "6:139": 146,
  "6:140": 146,
  "6:141": 146,
  "6:142": 146,
  "6:143": 147,
  "6:144": 147,
  "6:145": 147,
  "6:146": 147,
  "6:147": 148,
  "6:148": 148,
  "6:149": 148,
  "6:150": 148,
  "6:151": 148,
  "6:152": 149,
  "6:153": 149,
  "6:154": 149,
  "6:155": 149,
  "6:156": 149,
  "6:157": 149,
  "6:158": 150,
  "6:159": 150,
  "6:160": 150,
  "6:161": 150,
  "6:162": 150,
  "6:163": 150,
  "6:164": 150,
  "6:165": 150,
  "7:1": 151,
  "7:2": 151,
  "7:3": 151,
  "7:4": 151,
  "7:5": 151,
  "7:6": 151,
  "7:7": 151,
  "7:8": 151,
  "7:9": 151,
  "7:10": 151,
  "7:11": 151,
  "7:12": 152,
  "7:13": 152,
  "7:14": 152,
  "7:15": 152,
  "7:16": 152,
  "7:17": 152,
  "7:18": 152,
  "7:19": 152,
  "7:20": 152,
  "7:21": 152,
  "7:22": 152,
  "7:23": 153,
  "7:24": 153,
  "7:25": 153,
  "7:26": 153,
  "7:27": 153,
  "7:28": 153,
  "7:29": 153,
  "7:30": 153,
  "7:31": 154,
  "7:32": 154,
  "7:33": 154,
  "7:34": 154,
  "7:35": 154,
  "7:36": 154,
  "7:37": 154,
  "7:38": 155,
  "7:39": 155,
  "7:40": 155,
  "7:41": 155,
  "7:42": 155,
  "7:43": 155,
  "7:44": 156,
  "7:45": 156,
  "7:46": 156,
  "7:47": 156,
  "7:48": 156,
  "7:49": 156,
  "7:50": 156,
  "7:51": 156,
  "7:52": 157,
  "7:53": 157,
  "7:54": 157,
  "7:55": 157,
  "7:56": 157,
  "7:57": 157,
  "7:58": 158,
  "7:59": 158,
  "7:60": 158,
  "7:61": 158,
  "7:62": 158,
  "7:63": 158,
  "7:64": 158,
  "7:65": 158,
  "7:66": 158,
  "7:67": 158,
  "7:68": 159,
  "7:69": 159,
  "7:70": 159,
  "7:71": 159,
  "7:72": 159,
  "7:73": 159,
  "7:74": 160,
  "7:75": 160,
  "7:76": 160,
  "7:77": 160,
  "7:78": 160,
  "7:79": 160,
  "7:80": 160,
  "7:81": 160,
  "7:82": 161,
  "7:83": 161,
  "7:84": 161,
  "7:85": 161,
  "7:86": 161,
  "7:87": 161,
  "7:88": 162,
  "7:89": 162,
  "7:90": 162,
  "7:91": 162,
  "7:92": 162,
  "7:93": 162,
  "7:94": 162,
  "7:95": 162,
  "7:96": 163,
  "7:97": 163,
  "7:98": 163,
  "7:99": 163,
  "7:100": 163,
  "7:101": 163,
  "7:102": 163,
  "7:103": 163,
  "7:104": 163,
  "7:105": 164,
  "7:106": 164,
  "7:107": 164,
  "7:108": 164,
  "7:109": 164,
  "7:110": 164,
  "7:111": 164,
  "7:112": 164,
  "7:113": 164,
  "7:114": 164,
  "7:115": 164,
  "7:116": 164,
  "7:117": 164,
  "7:118": 164,
  "7:119": 164,
  "7:120": 164,
  "7:121": 165,
  "7:122": 165,
  "7:123": 165,
  "7:124": 165,
  "7:125": 165,
  "7:126": 165,
  "7:127": 165,
  "7:128": 165,
  "7:129": 165,
  "7:130": 165,
  "7:131": 166,
  "7:132": 166,
  "7:133": 166,
  "7:134": 166,
  "7:135": 166,
  "7:136": 166,
  "7:137": 166,
  "7:138": 167,
  "7:139": 167,
  "7:140": 167,
  "7:141": 167,
  "7:142": 167,
  "7:143": 167,
  "7:144": 168,
  "7:145": 168,
  "7:146": 168,
  "7:147": 168,
  "7:148": 168,
  "7:149": 168,
  "7:150": 169,
  "7:151": 169,
  "7:152": 169,
  "7:153": 169,
  "7:154": 169,
  "7:155": 169,
  "7:156": 170,
  "7:157": 170,
  "7:158": 170,
  "7:159": 170,
  "7:160": 171,
  "7:161": 171,
  "7:162": 171,
  "7:163": 171,
  "7:164": 172,
  "7:165": 172,
  "7:166": 172,
  "7:167": 172,
  "7:168": 172,
  "7:169": 172,
  "7:170": 172,
  "7:171": 173,
  "7:172": 173,
  "7:173": 173,
  "7:174": 173,
  "7:175": 173,
  "7:176": 173,
  "7:177": 173,
  "7:178": 173,
  "7:179": 174,
  "7:180": 174,
  "7:181": 174,
  "7:182": 174,
  "7:183": 174,
  "7:184": 174,
  "7:185": 174,
  "7:186": 174,
  "7:187": 174,
  "7:188": 175,
  "7:189": 175,
  "7:190": 175,
  "7:191": 175,
  "7:192": 175,
  "7:193": 175,
  "7:194": 175,
  "7:195": 175,
  "7:196": 176,
  "7:197": 176,
  "7:198": 176,
  "7:199": 176,
  "7:200": 176,
  "7:201": 176,
  "7:202": 176,
  "7:203": 176,
  "7:204": 176,
  "7:205": 176,
  "7:206": 176,
  "8:1": 177,
  "8:2": 177,
  "8:3": 177,
  "8:4": 177,
  "8:5": 177,
  "8:6": 177,
  "8:7": 177,
  "8:8": 177,
  "8:9": 178,
  "8:10": 178,
  "8:11": 178,
  "8:12": 178,
  "8:13": 178,
  "8:14": 178,
  "8:15": 178,
  "8:16": 178,
  "8:17": 179,
  "8:18": 179,
  "8:19": 179,
  "8:20": 179,
  "8:21": 179,
  "8:22": 179,
  "8:23": 179,
  "8:24": 179,
  "8:25": 179,
  "8:26": 180,
  "8:27": 180,
  "8:28": 180,
  "8:29": 180,
  "8:30": 180,
  "8:31": 180,
  "8:32": 180,
  "8:33": 180,
  "8:34": 181,
  "8:35": 181,
  "8:36": 181,
  "8:37": 181,
  "8:38": 181,
  "8:39": 181,
  "8:40": 181,
  "8:41": 182,
  "8:42": 182,
  "8:43": 182,
  "8:44": 182,
  "8:45": 182,
  "8:46": 183,
  "8:47": 183,
  "8:48": 183,
  "8:49": 183,
  "8:50": 183,
  "8:51": 183,
  "8:52": 183,
  "8:53": 184,
  "8:54": 184,
  "8:55": 184,
  "8:56": 184,
  "8:57": 184,
  "8:58": 184,
  "8:59": 184,
  "8:60": 184,
  "8:61": 184,
  "8:62": 185,
  "8:63": 185,
  "8:64": 185,
  "8:65": 185,
  "8:66": 185,
  "8:67": 185,
  "8:68": 185,
  "8:69": 185,
  "8:70": 186,
  "8:71": 186,
  "8:72": 186,
  "8:73": 186,
  "8:74": 186,
  "8:75": 186,
  "9:1": 187,
  "9:2": 187,
  "9:3": 187,
  "9:4": 187,
  "9:5": 187,
  "9:6": 187,
  "9:7": 188,
  "9:8": 188,
  "9:9": 188,
  "9:10": 188,
  "9:11": 188,
  "9:12": 188,
  "9:13": 188,
  "9:14": 189,
  "9:15": 189,
  "9:16": 189,
  "9:17": 189,
  "9:18": 189,
  "9:19": 189,
  "9:20": 189,
  "9:21": 190,
  "9:22": 190,
  "9:23": 190,
  "9:24": 190,
  "9:25": 190,
  "9:26": 190,
  "9:27": 191,
  "9:28": 191,
  "9:29": 191,
  "9:30": 191,
  "9:31": 191,
  "9:32": 192,
  "9:33": 192,
  "9:34": 192,
  "9:35": 192,
  "9:36": 192,
  "9:37": 193,
  "9:38": 193,
  "9:39": 193,
  "9:40": 193,
  "9:41": 194,
  "9:42": 194,
  "9:43": 194,
  "9:44": 194,
  "9:45": 194,
  "9:46": 194,
  "9:47": 194,
  "9:48": 195,
  "9:49": 195,
  "9:50": 195,
  "9:51": 195,
  "9:52": 195,
  "9:53": 195,
  "9:54": 195,
  "9:55": 196,
  "9:56": 196,
  "9:57": 196,
  "9:58": 196,
  "9:59": 196,
  "9:60": 196,
  "9:61": 196,
  "9:62": 197,
  "9:63": 197,
  "9:64": 197,
  "9:65": 197,
  "9:66": 197,
  "9:67": 197,
  "9:68": 197,
  "9:69": 198,
  "9:70": 198,
  "9:71": 198,
  "9:72": 198,
  "9:73": 199,
  "9:74": 199,
  "9:75": 199,
  "9:76": 199,
  "9:77": 199,
  "9:78": 199,
  "9:79": 199,
  "9:80": 200,
  "9:81": 200,
  "9:82": 200,
  "9:83": 200,
  "9:84": 200,
  "9:85": 200,
  "9:86": 200,
  "9:87": 201,
  "9:88": 201,
  "9:89": 201,
  "9:90": 201,
  "9:91": 201,
  "9:92": 201,
  "9:93": 201,
  "9:94": 202,
  "9:95": 202,
  "9:96": 202,
  "9:97": 202,
  "9:98": 202,
  "9:99": 202,
  "9:100": 203,
  "9:101": 203,
  "9:102": 203,
  "9:103": 203,
  "9:104": 203,
  "9:105": 203,
  "9:106": 203,
  "9:107": 204,
  "9:108": 204,
  "9:109": 204,
  "9:110": 204,
  "9:111": 204,
  "9:112": 205,
  "9:113": 205,
  "9:114": 205,
  "9:115": 205,
  "9:116": 205,
  "9:117": 205,
  "9:118": 206,
  "9:119": 206,
  "9:120": 206,
  "9:121": 206,
  "9:122": 206,
  "9:123": 207,
  "9:124": 207,
  "9:125": 207,
  "9:126": 207,
  "9:127": 207,
  "9:128": 207,
  "9:129": 207,
  "10:1": 208,
  "10:2": 208,
  "10:3": 208,
  "10:4": 208,
  "10:5": 208,
  "10:6": 208,
  "10:7": 209,
  "10:8": 209,
  "10:9": 209,
  "10:10": 209,
  "10:11": 209,
  "10:12": 209,
  "10:13": 209,
  "10:14": 209,
  "10:15": 210,
  "10:16": 210,
  "10:17": 210,
  "10:18": 210,
  "10:19": 210,
  "10:20": 210,
  "10:21": 211,
  "10:22": 211,
  "10:23": 211,
  "10:24": 211,
  "10:25": 211,
  "10:26": 212,
  "10:27": 212,
  "10:28": 212,
  "10:29": 212,
  "10:30": 212,
  "10:31": 212,
  "10:32": 212,
  "10:33": 212,
  "10:34": 213,
  "10:35": 213,
  "10:36": 213,
  "10:37": 213,
  "10:38": 213,
  "10:39": 213,
  "10:40": 213,
  "10:41": 213,
  "10:42": 213,
  "10:43": 214,
  "10:44": 214,
  "10:45": 214,
  "10:46": 214,
  "10:47": 214,
  "10:48": 214,
  "10:49": 214,
  "10:50": 214,
  "10:51": 214,
  "10:52": 214,
  "10:53": 214,
  "10:54": 215,
  "10:55": 215,
  "10:56": 215,
  "10:57": 215,
  "10:58": 215,
  "10:59": 215,
  "10:60": 215,
  "10:61": 215,
  "10:62": 216,
  "10:63": 216,
  "10:64": 216,
  "10:65": 216,
  "10:66": 216,
  "10:67": 216,
  "10:68": 216,
  "10:69": 216,
  "10:70": 216,
  "10:71": 217,
  "10:72": 217,
  "10:73": 217,
  "10:74": 217,
  "10:75": 217,
  "10:76": 217,
  "10:77": 217,
  "10:78": 217,
  "10:79": 218,
  "10:80": 218,
  "10:81": 218,
  "10:82": 218,
  "10:83": 218,
  "10:84": 218,
  "10:85": 218,
  "10:86": 218,
  "10:87": 218,
  "10:88": 218,
  "10:89": 219,
  "10:90": 219,
  "10:91": 219,
  "10:92": 219,
  "10:93": 219,
  "10:94": 219,
  "10:95": 219,
  "10:96": 219,
  "10:97": 219,
  "10:98": 220,
  "10:99": 220,
  "10:100": 220,
  "10:101": 220,
  "10:102": 220,
  "10:103": 220,
  "10:104": 220,
  "10:105": 220,
  "10:106": 220,
  "10:107": 221,
  "10:108": 221,
  "10:109": 221,
  "11:1": 221,
  "11:2": 221,
  "11:3": 221,
  "11:4": 221,
  "11:5": 221,
  "11:6": 222,
  "11:7": 222,
  "11:8": 222,
  "11:9": 222,
  "11:10": 222,
  "11:11": 222,
  "11:12": 222,
  "11:13": 223,
  "11:14": 223,
  "11:15": 223,
  "11:16": 223,
  "11:17": 223,
  "11:18": 223,
  "11:19": 223,
  "11:20": 224,
  "11:21": 224,
  "11:22": 224,
  "11:23": 224,
  "11:24": 224,
  "11:25": 224,
  "11:26": 224,
  "11:27": 224,
  "11:28": 224,
  "11:29": 225,
  "11:30": 225,
  "11:31": 225,
  "11:32": 225,
  "11:33": 225,
  "11:34": 225,
  "11:35": 225,
  "11:36": 225,
  "11:37": 225,
  "11:38": 226,
  "11:39": 226,
  "11:40": 226,
  "11:41": 226,
  "11:42": 226,
  "11:43": 226,
  "11:44": 226,
  "11:45": 226,
  "11:46": 227,
  "11:47": 227,
  "11:48": 227,
  "11:49": 227,
  "11:50": 227,
  "11:51": 227,
  "11:52": 227,
  "11:53": 227,
  "11:54": 228,
  "11:55": 228,
  "11:56": 228,
  "11:57": 228,
  "11:58": 228,
  "11:59": 228,
  "11:60": 228,
  "11:61": 228,
  "11:62": 228,
  "11:63": 229,
  "11:64": 229,
  "11:65": 229,
  "11:66": 229,
  "11:67": 229,
  "11:68": 229,
  "11:69": 229,
  "11:70": 229,
  "11:71": 229,
  "11:72": 230,
  "11:73": 230,
  "11:74": 230,
  "11:75": 230,
  "11:76": 230,
  "11:77": 230,
  "11:78": 230,
  "11:79": 230,
  "11:80": 230,
  "11:81": 230,
  "11:82": 231,
  "11:83": 231,
  "11:84": 231,
  "11:85": 231,
  "11:86": 231,
  "11:87": 231,
  "11:88": 231,
  "11:89": 232,
  "11:90": 232,
  "11:91": 232,
  "11:92": 232,
  "11:93": 232,
  "11:94": 232,
  "11:95": 232,
  "11:96": 232,
  "11:97": 232,
  "11:98": 233,
  "11:99": 233,
  "11:100": 233,
  "11:101": 233,
  "11:102": 233,
  "11:103": 233,
  "11:104": 233,
  "11:105": 233,
  "11:106": 233,
  "11:107": 233,
  "11:108": 233,
  "11:109": 234,
  "11:110": 234,
  "11:111": 234,
  "11:112": 234,
  "11:113": 234,
  "11:114": 234,
  "11:115": 234,
  "11:116": 234,
  "11:117": 234,
  "11:118": 235,
  "11:119": 235,
  "11:120": 235,
  "11:121": 235,
  "11:122": 235,
  "11:123": 235,
  "12:1": 235,
  "12:2": 235,
  "12:3": 235,
  "12:4": 235,
  "12:5": 236,
  "12:6": 236,
  "12:7": 236,
  "12:8": 236,
  "12:9": 236,
  "12:10": 236,
  "12:11": 236,
  "12:12": 236,
  "12:13": 236,
  "12:14": 236,
  "12:15": 237,
  "12:16": 237,
  "12:17": 237,
  "12:18": 237,
  "12:19": 237,
  "12:20": 237,
  "12:21": 237,
  "12:22": 237,
  "12:23": 238,
  "12:24": 238,
  "12:25": 238,
  "12:26": 238,
  "12:27": 238,
  "12:28": 238,
  "12:29": 238,
  "12:30": 238,
  "12:31": 239,
  "12:32": 239,
  "12:33": 239,
  "12:34": 239,
  "12:35": 239,
  "12:36": 239,
  "12:37": 239,
  "12:38": 240,
  "12:39": 240,
  "12:40": 240,
  "12:41": 240,
  "12:42": 240,
  "12:43": 240,
  "12:44": 241,
  "12:45": 241,
  "12:46": 241,
  "12:47": 241,
  "12:48": 241,
  "12:49": 241,
  "12:50": 241,
  "12:51": 241,
  "12:52": 241,
  "12:53": 242,
  "12:54": 242,
  "12:55": 242,
  "12:56": 242,
  "12:57": 242,
  "12:58": 242,
  "12:59": 242,
  "12:60": 242,
  "12:61": 242,
  "12:62": 242,
  "12:63": 242,
  "12:64": 243,
  "12:65": 243,
  "12:66": 243,
  "12:67": 243,
  "12:68": 243,
  "12:69": 243,
  "12:70": 244,
  "12:71": 244,
  "12:72": 244,
  "12:73": 244,
  "12:74": 244,
  "12:75": 244,
  "12:76": 244,
  "12:77": 244,
  "12:78": 244,
  "12:79": 245,
  "12:80": 245,
  "12:81": 245,
  "12:82": 245,
  "12:83": 245,
  "12:84": 245,
  "12:85": 245,
  "12:86": 245,
  "12:87": 246,
  "12:88": 246,
  "12:89": 246,
  "12:90": 246,
  "12:91": 246,
  "12:92": 246,
  "12:93": 246,
  "12:94": 246,
  "12:95": 246,
  "12:96": 247,
  "12:97": 247,
  "12:98": 247,
  "12:99": 247,
  "12:100": 247,
  "12:101": 247,
  "12:102": 247,
  "12:103": 247,
  "12:104": 248,
  "12:105": 248,
  "12:106": 248,
  "12:107": 248,
  "12:108": 248,
  "12:109": 248,
  "12:110": 248,
  "12:111": 248,
  "13:1": 249,
  "13:2": 249,
  "13:3": 249,
  "13:4": 249,
  "13:5": 249,
  "13:6": 250,
  "13:7": 250,
  "13:8": 250,
  "13:9": 250,
  "13:10": 250,
  "13:11": 250,
  "13:12": 250,
  "13:13": 250,
  "13:14": 251,
  "13:15": 251,
  "13:16": 251,
  "13:17": 251,
  "13:18": 251,
  "13:19": 252,
  "13:20": 252,
  "13:21": 252,
  "13:22": 252,
  "13:23": 252,
  "13:24": 252,
  "13:25": 252,
  "13:26": 252,
  "13:27": 252,
  "13:28": 252,
  "13:29": 253,
  "13:30": 253,
  "13:31": 253,
  "13:32": 253,
  "13:33": 253,
  "13:34": 253,
  "13:35": 254,
  "13:36": 254,
  "13:37": 254,
  "13:38": 254,
  "13:39": 254,
  "13:40": 254,
  "13:41": 254,
  "13:42": 254,
  "13:43": 255,
  "14:1": 255,
  "14:2": 255,
  "14:3": 255,
  "14:4": 255,
  "14:5": 255,
  "14:6": 256,
  "14:7": 256,
  "14:8": 256,
  "14:9": 256,
  "14:10": 256,
  "14:11": 257,
  "14:12": 257,
  "14:13": 257,
  "14:14": 257,
  "14:15": 257,
  "14:16": 257,
  "14:17": 257,
  "14:18": 257,
  "14:19": 258,
  "14:20": 258,
  "14:21": 258,
  "14:22": 258,
  "14:23": 258,
  "14:24": 258,
  "14:25": 259,
  "14:26": 259,
  "14:27": 259,
  "14:28": 259,
  "14:29": 259,
  "14:30": 259,
  "14:31": 259,
  "14:32": 259,
  "14:33": 259,
  "14:34": 260,
  "14:35": 260,
  "14:36": 260,
  "14:37": 260,
  "14:38": 260,
  "14:39": 260,
  "14:40": 260,
  "14:41": 260,
  "14:42": 260,
  "14:43": 261,
  "14:44": 261,
  "14:45": 261,
  "14:46": 261,
  "14:47": 261,
  "14:48": 261,
  "14:49": 261,
  "14:50": 261,
  "14:51": 261,
  "14:52": 261,
  "15:1": 262,
  "15:2": 262,
  "15:3": 262,
  "15:4": 262,
  "15:5": 262,
  "15:6": 262,
  "15:7": 262,
  "15:8": 262,
  "15:9": 262,
  "15:10": 262,
  "15:11": 262,
  "15:12": 262,
  "15:13": 262,
  "15:14": 262,
  "15:15": 262,
  "15:16": 263,
  "15:17": 263,
  "15:18": 263,
  "15:19": 263,
  "15:20": 263,
  "15:21": 263,
  "15:22": 263,
  "15:23": 263,
  "15:24": 263,
  "15:25": 263,
  "15:26": 263,
  "15:27": 263,
  "15:28": 263,
  "15:29": 263,
  "15:30": 263,
  "15:31": 263,
  "15:32": 264,
  "15:33": 264,
  "15:34": 264,
  "15:35": 264,
  "15:36": 264,
  "15:37": 264,
  "15:38": 264,
  "15:39": 264,
  "15:40": 264,
  "15:41": 264,
  "15:42": 264,
  "15:43": 264,
  "15:44": 264,
  "15:45": 264,
  "15:46": 264,
  "15:47": 264,
  "15:48": 264,
  "15:49": 264,
  "15:50": 264,
  "15:51": 264,
  "15:52": 265,
  "15:53": 265,
  "15:54": 265,
  "15:55": 265,
  "15:56": 265,
  "15:57": 265,
  "15:58": 265,
  "15:59": 265,
  "15:60": 265,
  "15:61": 265,
  "15:62": 265,
  "15:63": 265,
  "15:64": 265,
  "15:65": 265,
  "15:66": 265,
  "15:67": 265,
  "15:68": 265,
  "15:69": 265,
  "15:70": 265,
  "15:71": 266,
  "15:72": 266,
  "15:73": 266,
  "15:74": 266,
  "15:75": 266,
  "15:76": 266,
  "15:77": 266,
  "15:78": 266,
  "15:79": 266,
  "15:80": 266,
  "15:81": 266,
  "15:82": 266,
  "15:83": 266,
  "15:84": 266,
  "15:85": 266,
  "15:86": 266,
  "15:87": 266,
  "15:88": 266,
  "15:89": 266,
  "15:90": 266,
  "15:91": 267,
  "15:92": 267,
  "15:93": 267,
  "15:94": 267,
  "15:95": 267,
  "15:96": 267,
  "15:97": 267,
  "15:98": 267,
  "15:99": 267,
  "16:1": 267,
  "16:2": 267,
  "16:3": 267,
  "16:4": 267,
  "16:5": 267,
  "16:6": 267,
  "16:7": 268,
  "16:8": 268,
  "16:9": 268,
  "16:10": 268,
  "16:11": 268,
  "16:12": 268,
  "16:13": 268,
  "16:14": 268,
  "16:15": 269,
  "16:16": 269,
  "16:17": 269,
  "16:18": 269,
  "16:19": 269,
  "16:20": 269,
  "16:21": 269,
  "16:22": 269,
  "16:23": 269,
  "16:24": 269,
  "16:25": 269,
  "16:26": 269,
  "16:27": 270,
  "16:28": 270,
  "16:29": 270,
  "16:30": 270,
  "16:31": 270,
  "16:32": 270,
  "16:33": 270,
  "16:34": 270,
  "16:35": 271,
  "16:36": 271,
  "16:37": 271,
  "16:38": 271,
  "16:39": 271,
  "16:40": 271,
  "16:41": 271,
  "16:42": 271,
  "16:43": 272,
  "16:44": 272,
  "16:45": 272,
  "16:46": 272,
  "16:47": 272,
  "16:48": 272,
  "16:49": 272,
  "16:50": 272,
  "16:51": 272,
  "16:52": 272,
  "16:53": 272,
  "16:54": 272,
  "16:55": 273,
  "16:56": 273,
  "16:57": 273,
  "16:58": 273,
  "16:59": 273,
  "16:60": 273,
  "16:61": 273,
  "16:62": 273,
  "16:63": 273,
  "16:64": 273,
  "16:65": 274,
  "16:66": 274,
  "16:67": 274,
  "16:68": 274,
  "16:69": 274,
  "16:70": 274,
  "16:71": 274,
  "16:72": 274,
  "16:73": 275,
  "16:74": 275,
  "16:75": 275,
  "16:76": 275,
  "16:77": 275,
  "16:78": 275,
  "16:79": 275,
  "16:80": 276,
  "16:81": 276,
  "16:82": 276,
  "16:83": 276,
  "16:84": 276,
  "16:85": 276,
  "16:86": 276,
  "16:87": 276,
  "16:88": 277,
  "16:89": 277,
  "16:90": 277,
  "16:91": 277,
  "16:92": 277,
  "16:93": 277,
  "16:94": 278,
  "16:95": 278,
  "16:96": 278,
  "16:97": 278,
  "16:98": 278,
  "16:99": 278,
  "16:100": 278,
  "16:101": 278,
  "16:102": 278,
  "16:103": 279,
  "16:104": 279,
  "16:105": 279,
  "16:106": 279,
  "16:107": 279,
  "16:108": 279,
  "16:109": 279,
  "16:110": 279,
  "16:111": 280,
  "16:112": 280,
  "16:113": 280,
  "16:114": 280,
  "16:115": 280,
  "16:116": 280,
  "16:117": 280,
  "16:118": 280,
  "16:119": 281,
  "16:120": 281,
  "16:121": 281,
  "16:122": 281,
  "16:123": 281,
  "16:124": 281,
  "16:125": 281,
  "16:126": 281,
  "16:127": 281,
  "16:128": 281,
  "17:1": 282,
  "17:2": 282,
  "17:3": 282,
  "17:4": 282,
  "17:5": 282,
  "17:6": 282,
  "17:7": 282,
  "17:8": 283,
  "17:9": 283,
  "17:10": 283,
  "17:11": 283,
  "17:12": 283,
  "17:13": 283,
  "17:14": 283,
  "17:15": 283,
  "17:16": 283,
  "17:17": 283,
  "17:18": 284,
  "17:19": 284,
  "17:20": 284,
  "17:21": 284,
  "17:22": 284,
  "17:23": 284,
  "17:24": 284,
  "17:25": 284,
  "17:26": 284,
  "17:27": 284,
  "17:28": 285,
  "17:29": 285,
  "17:30": 285,
  "17:31": 285,
  "17:32": 285,
  "17:33": 285,
  "17:34": 285,
  "17:35": 285,
  "17:36": 285,
  "17:37": 285,
  "17:38": 285,
  "17:39": 286,
  "17:40": 286,
  "17:41": 286,
  "17:42": 286,
  "17:43": 286,
  "17:44": 286,
  "17:45": 286,
  "17:46": 286,
  "17:47": 286,
  "17:48": 286,
  "17:49": 286,
  "17:50": 287,
  "17:51": 287,
  "17:52": 287,
  "17:53": 287,
  "17:54": 287,
  "17:55": 287,
  "17:56": 287,
  "17:57": 287,
  "17:58": 287,
  "17:59": 288,
  "17:60": 288,
  "17:61": 288,
  "17:62": 288,
  "17:63": 288,
  "17:64": 288,
  "17:65": 288,
  "17:66": 288,
  "17:67": 289,
  "17:68": 289,
  "17:69": 289,
  "17:70": 289,
  "17:71": 289,
  "17:72": 289,
  "17:73": 289,
  "17:74": 289,
  "17:75": 289,
  "17:76": 290,
  "17:77": 290,
  "17:78": 290,
  "17:79": 290,
  "17:80": 290,
  "17:81": 290,
  "17:82": 290,
  "17:83": 290,
  "17:84": 290,
  "17:85": 290,
  "17:86": 290,
  "17:87": 291,
  "17:88": 291,
  "17:89": 291,
  "17:90": 291,
  "17:91": 291,
  "17:92": 291,
  "17:93": 291,
  "17:94": 291,
  "17:95": 291,
  "17:96": 291,
  "17:97": 292,
  "17:98": 292,
  "17:99": 292,
  "17:100": 292,
  "17:101": 292,
  "17:102": 292,
  "17:103": 292,
  "17:104": 292,
  "17:105": 293,
  "17:106": 293,
  "17:107": 293,
  "17:108": 293,
  "17:109": 293,
  "17:110": 293,
  "17:111": 293,
  "18:1": 293,
  "18:2": 293,
  "18:3": 293,
  "18:4": 293,
  "18:5": 294,
  "18:6": 294,
  "18:7": 294,
  "18:8": 294,
  "18:9": 294,
  "18:10": 294,
  "18:11": 294,
  "18:12": 294,
  "18:13": 294,
  "18:14": 294,
  "18:15": 294,
  "18:16": 295,
  "18:17": 295,
  "18:18": 295,
  "18:19": 295,
  "18:20": 295,
  "18:21": 296,
  "18:22": 296,
  "18:23": 296,
  "18:24": 296,
  "18:25": 296,
  "18:26": 296,
  "18:27": 296,
  "18:28": 297,
  "18:29": 297,
  "18:30": 297,
  "18:31": 297,
  "18:32": 297,
  "18:33": 297,
  "18:34": 297,
  "18:35": 298,
  "18:36": 298,
  "18:37": 298,
  "18:38": 298,
  "18:39": 298,
  "18:40": 298,
  "18:41": 298,
  "18:42": 298,
  "18:43": 298,
  "18:44": 298,
  "18:45": 298,
  "18:46": 299,
  "18:47": 299,
  "18:48": 299,
  "18:49": 299,
  "18:50": 299,
  "18:51": 299,
  "18:52": 299,
  "18:53": 299,
  "18:54": 300,
  "18:55": 300,
  "18:56": 300,
  "18:57": 300,
  "18:58": 300,
  "18:59": 300,
  "18:60": 300,
  "18:61": 300,
  "18:62": 301,
  "18:63": 301,
  "18:64": 301,
  "18:65": 301,
  "18:66": 301,
  "18:67": 301,
  "18:68": 301,
  "18:69": 301,
  "18:70": 301,
  "18:71": 301,
  "18:72": 301,
  "18:73": 301,
  "18:74": 301,
  "18:75": 302,
  "18:76": 302,
  "18:77": 302,
  "18:78": 302,
  "18:79": 302,
  "18:80": 302,
  "18:81": 302,
  "18:82": 302,
  "18:83": 302,
  "18:84": 303,
  "18:85": 303,
  "18:86": 303,
  "18:87": 303,
  "18:88": 303,
  "18:89": 303,
  "18:90": 303,
  "18:91": 303,
  "18:92": 303,
  "18:93": 303,
  "18:94": 303,
  "18:95": 303,
  "18:96": 303,
  "18:97": 303,
  "18:98": 304,
  "18:99": 304,
  "18:100": 304,
  "18:101": 304,
  "18:102": 304,
  "18:103": 304,
  "18:104": 304,
  "18:105": 304,
  "18:106": 304,
  "18:107": 304,
  "18:108": 304,
  "18:109": 304,
  "18:110": 304,
  "19:1": 305,
  "19:2": 305,
  "19:3": 305,
  "19:4": 305,
  "19:5": 305,
  "19:6": 305,
  "19:7": 305,
  "19:8": 305,
  "19:9": 305,
  "19:10": 305,
  "19:11": 305,
  "19:12": 306,
  "19:13": 306,
  "19:14": 306,
  "19:15": 306,
  "19:16": 306,
  "19:17": 306,
  "19:18": 306,
  "19:19": 306,
  "19:20": 306,
  "19:21": 306,
  "19:22": 306,
  "19:23": 306,
  "19:24": 306,
  "19:25": 306,
  "19:26": 307,
  "19:27": 307,
  "19:28": 307,
  "19:29": 307,
  "19:30": 307,
  "19:31": 307,
  "19:32": 307,
  "19:33": 307,
  "19:34": 307,
  "19:35": 307,
  "19:36": 307,
  "19:37": 307,
  "19:38": 307,
  "19:39": 308,
  "19:40": 308,
  "19:41": 308,
  "19:42": 308,
  "19:43": 308,
  "19:44": 308,
  "19:45": 308,
  "19:46": 308,
  "19:47": 308,
  "19:48": 308,
  "19:49": 308,
  "19:50": 308,
  "19:51": 308,
  "19:52": 309,
  "19:53": 309,
  "19:54": 309,
  "19:55": 309,
  "19:56": 309,
  "19:57": 309,
  "19:58": 309,
  "19:59": 309,
  "19:60": 309,
  "19:61": 309,
  "19:62": 309,
  "19:63": 309,
  "19:64": 309,
  "19:65": 310,
  "19:66": 310,
  "19:67": 310,
  "19:68": 310,
  "19:69": 310,
  "19:70": 310,
  "19:71": 310,
  "19:72": 310,
  "19:73": 310,
  "19:74": 310,
  "19:75": 310,
  "19:76": 310,
  "19:77": 311,
  "19:78": 311,
  "19:79": 311,
  "19:80": 311,
  "19:81": 311,
  "19:82": 311,
  "19:83": 311,
  "19:84": 311,
  "19:85": 311,
  "19:86": 311,
  "19:87": 311,
  "19:88": 311,
  "19:89": 311,
  "19:90": 311,
  "19:91": 311,
  "19:92": 311,
  "19:93": 311,
  "19:94": 311,
  "19:95": 311,
  "19:96": 312,
  "19:97": 312,
  "19:98": 312,
  "20:1": 312,
  "20:2": 312,
  "20:3": 312,
  "20:4": 312,
  "20:5": 312,
  "20:6": 312,
  "20:7": 312,
  "20:8": 312,
  "20:9": 312,
  "20:10": 312,
  "20:11": 312,
  "20:12": 312,
  "20:13": 313,
  "20:14": 313,
  "20:15": 313,
  "20:16": 313,
  "20:17": 313,
  "20:18": 313,
  "20:19": 313,
  "20:20": 313,
  "20:21": 313,
  "20:22": 313,
  "20:23": 313,
  "20:24": 313,
  "20:25": 313,
  "20:26": 313,
  "20:27": 313,
  "20:28": 313,
  "20:29": 313,
  "20:30": 313,
  "20:31": 313,
  "20:32": 313,
  "20:33": 313,
  "20:34": 313,
  "20:35": 313,
  "20:36": 313,
  "20:37": 313,
  "20:38": 314,
  "20:39": 314,
  "20:40": 314,
  "20:41": 314,
  "20:42": 314,
  "20:43": 314,
  "20:44": 314,
  "20:45": 314,
  "20:46": 314,
  "20:47": 314,
  "20:48": 314,
  "20:49": 314,
  "20:50": 314,
  "20:51": 314,
  "20:52": 315,
  "20:53": 315,
  "20:54": 315,
  "20:55": 315,
  "20:56": 315,
  "20:57": 315,
  "20:58": 315,
  "20:59": 315,
  "20:60": 315,
  "20:61": 315,
  "20:62": 315,
  "20:63": 315,
  "20:64": 315,
  "20:65": 316,
  "20:66": 316,
  "20:67": 316,
  "20:68": 316,
  "20:69": 316,
  "20:70": 316,
  "20:71": 316,
  "20:72": 316,
  "20:73": 316,
  "20:74": 316,
  "20:75": 316,
  "20:76": 316,
  "20:77": 317,
  "20:78": 317,
  "20:79": 317,
  "20:80": 317,
  "20:81": 317,
  "20:82": 317,
  "20:83": 317,
  "20:84": 317,
  "20:85": 317,
  "20:86": 317,
  "20:87": 317,
  "20:88": 318,
  "20:89": 318,
  "20:90": 318,
  "20:91": 318,
  "20:92": 318,
  "20:93": 318,
  "20:94": 318,
  "20:95": 318,
  "20:96": 318,
  "20:97": 318,
  "20:98": 318,
  "20:99": 319,
  "20:100": 319,
  "20:101": 319,
  "20:102": 319,
  "20:103": 319,
  "20:104": 319,
  "20:105": 319,
  "20:106": 319,
  "20:107": 319,
  "20:108": 319,
  "20:109": 319,
  "20:110": 319,
  "20:111": 319,
  "20:112": 319,
  "20:113": 319,
  "20:114": 320,
  "20:115": 320,
  "20:116": 320,
  "20:117": 320,
  "20:118": 320,
  "20:119": 320,
  "20:120": 320,
  "20:121": 320,
  "20:122": 320,
  "20:123": 320,
  "20:124": 320,
  "20:125": 320,
  "20:126": 321,
  "20:127": 321,
  "20:128": 321,
  "20:129": 321,
  "20:130": 321,
  "20:131": 321,
  "20:132": 321,
  "20:133": 321,
  "20:134": 321,
  "20:135": 321,
  "21:1": 322,
  "21:2": 322,
  "21:3": 322,
  "21:4": 322,
  "21:5": 322,
  "21:6": 322,
  "21:7": 322,
  "21:8": 322,
  "21:9": 322,
  "21:10": 322,
  "21:11": 323,
  "21:12": 323,
  "21:13": 323,
  "21:14": 323,
  "21:15": 323,
  "21:16": 323,
  "21:17": 323,
  "21:18": 323,
  "21:19": 323,
  "21:20": 323,
  "21:21": 323,
  "21:22": 323,
  "21:23": 323,
  "21:24": 323,
  "21:25": 324,
  "21:26": 324,
  "21:27": 324,
  "21:28": 324,
  "21:29": 324,
  "21:30": 324,
  "21:31": 324,
  "21:32": 324,
  "21:33": 324,
  "21:34": 324,
  "21:35": 324,
  "21:36": 325,
  "21:37": 325,
  "21:38": 325,
  "21:39": 325,
  "21:40": 325,
  "21:41": 325,
  "21:42": 325,
  "21:43": 325,
  "21:44": 325,
  "21:45": 326,
  "21:46": 326,
  "21:47": 326,
  "21:48": 326,
  "21:49": 326,
  "21:50": 326,
  "21:51": 326,
  "21:52": 326,
  "21:53": 326,
  "21:54": 326,
  "21:55": 326,
  "21:56": 326,
  "21:57": 326,
  "21:58": 327,
  "21:59": 327,
  "21:60": 327,
  "21:61": 327,
  "21:62": 327,
  "21:63": 327,
  "21:64": 327,
  "21:65": 327,
  "21:66": 327,
  "21:67": 327,
  "21:68": 327,
  "21:69": 327,
  "21:70": 327,
  "21:71": 327,
  "21:72": 327,
  "21:73": 328,
  "21:74": 328,
  "21:75": 328,
  "21:76": 328,
  "21:77": 328,
  "21:78": 328,
  "21:79": 328,
  "21:80": 328,
  "21:81": 328,
  "21:82": 329,
  "21:83": 329,
  "21:84": 329,
  "21:85": 329,
  "21:86": 329,
  "21:87": 329,
  "21:88": 329,
  "21:89": 329,
  "21:90": 329,
  "21:91": 330,
  "21:92": 330,
  "21:93": 330,
  "21:94": 330,
  "21:95": 330,
  "21:96": 330,
  "21:97": 330,
  "21:98": 330,
  "21:99": 330,
  "21:100": 330,
  "21:101": 330,
  "21:102": 331,
  "21:103": 331,
  "21:104": 331,
  "21:105": 331,
  "21:106": 331,
  "21:107": 331,
  "21:108": 331,
  "21:109": 331,
  "21:110": 331,
  "21:111": 331,
  "21:112": 331,
  "22:1": 332,
  "22:2": 332,
  "22:3": 332,
  "22:4": 332,
  "22:5": 332,
  "22:6": 333,
  "22:7": 333,
  "22:8": 333,
  "22:9": 333,
  "22:10": 333,
  "22:11": 333,
  "22:12": 333,
  "22:13": 333,
  "22:14": 333,
  "22:15": 333,
  "22:16": 334,
  "22:17": 334,
  "22:18": 334,
  "22:19": 334,
  "22:20": 334,
  "22:21": 334,
  "22:22": 334,
  "22:23": 334,
  "22:24": 335,
  "22:25": 335,
  "22:26": 335,
  "22:27": 335,
  "22:28": 335,
  "22:29": 335,
  "22:30": 335,
  "22:31": 336,
  "22:32": 336,
  "22:33": 336,
  "22:34": 336,
  "22:35": 336,
  "22:36": 336,
  "22:37": 336,
  "22:38": 336,
  "22:39": 337,
  "22:40": 337,
  "22:41": 337,
  "22:42": 337,
  "22:43": 337,
  "22:44": 337,
  "22:45": 337,
  "22:46": 337,
  "22:47": 338,
  "22:48": 338,
  "22:49": 338,
  "22:50": 338,
  "22:51": 338,
  "22:52": 338,
  "22:53": 338,
  "22:54": 338,
  "22:55": 338,
  "22:56": 339,
  "22:57": 339,
  "22:58": 339,
  "22:59": 339,
  "22:60": 339,
  "22:61": 339,
  "22:62": 339,
  "22:63": 339,
  "22:64": 339,
  "22:65": 340,
  "22:66": 340,
  "22:67": 340,
  "22:68": 340,
  "22:69": 340,
  "22:70": 340,
  "22:71": 340,
  "22:72": 340,
  "22:73": 341,
  "22:74": 341,
  "22:75": 341,
  "22:76": 341,
  "22:77": 341,
  "22:78": 341,
  "23:1": 342,
  "23:2": 342,
  "23:3": 342,
  "23:4": 342,
  "23:5": 342,
  "23:6": 342,
  "23:7": 342,
  "23:8": 342,
  "23:9": 342,
  "23:10": 342,
  "23:11": 342,
  "23:12": 342,
  "23:13": 342,
  "23:14": 342,
  "23:15": 342,
  "23:16": 342,
  "23:17": 342,
  "23:18": 343,
  "23:19": 343,
  "23:20": 343,
  "23:21": 343,
  "23:22": 343,
  "23:23": 343,
  "23:24": 343,
  "23:25": 343,
  "23:26": 343,
  "23:27": 343,
  "23:28": 344,
  "23:29": 344,
  "23:30": 344,
  "23:31": 344,
  "23:32": 344,
  "23:33": 344,
  "23:34": 344,
  "23:35": 344,
  "23:36": 344,
  "23:37": 344,
  "23:38": 344,
  "23:39": 344,
  "23:40": 344,
  "23:41": 344,
  "23:42": 344,
  "23:43": 345,
  "23:44": 345,
  "23:45": 345,
  "23:46": 345,
  "23:47": 345,
  "23:48": 345,
  "23:49": 345,
  "23:50": 345,
  "23:51": 345,
  "23:52": 345,
  "23:53": 345,
  "23:54": 345,
  "23:55": 345,
  "23:56": 345,
  "23:57": 345,
  "23:58": 345,
  "23:59": 345,
  "23:60": 346,
  "23:61": 346,
  "23:62": 346,
  "23:63": 346,
  "23:64": 346,
  "23:65": 346,
  "23:66": 346,
  "23:67": 346,
  "23:68": 346,
  "23:69": 346,
  "23:70": 346,
  "23:71": 346,
  "23:72": 346,
  "23:73": 346,
  "23:74": 346,
  "23:75": 347,
  "23:76": 347,
  "23:77": 347,
  "23:78": 347,
  "23:79": 347,
  "23:80": 347,
  "23:81": 347,
  "23:82": 347,
  "23:83": 347,
  "23:84": 347,
  "23:85": 347,
  "23:86": 347,
  "23:87": 347,
  "23:88": 347,
  "23:89": 347,
  "23:90": 348,
  "23:91": 348,
  "23:92": 348,
  "23:93": 348,
  "23:94": 348,
  "23:95": 348,
  "23:96": 348,
  "23:97": 348,
  "23:98": 348,
  "23:99": 348,
  "23:100": 348,
  "23:101": 348,
  "23:102": 348,
  "23:103": 348,
  "23:104": 348,
  "23:105": 349,
  "23:106": 349,
  "23:107": 349,
  "23:108": 349,
  "23:109": 349,
  "23:110": 349,
  "23:111": 349,
  "23:112": 349,
  "23:113": 349,
  "23:114": 349,
  "23:115": 349,
  "23:116": 349,
  "23:117": 349,
  "23:118": 349,
  "24:1": 350,
  "24:2": 350,
  "24:3": 350,
  "24:4": 350,
  "24:5": 350,
  "24:6": 350,
  "24:7": 350,
  "24:8": 350,
  "24:9": 350,
  "24:10": 350,
  "24:11": 351,
  "24:12": 351,
  "24:13": 351,
  "24:14": 351,
  "24:15": 351,
  "24:16": 351,
  "24:17": 351,
  "24:18": 351,
  "24:19": 351,
  "24:20": 351,
  "24:21": 352,
  "24:22": 352,
  "24:23": 352,
  "24:24": 352,
  "24:25": 352,
  "24:26": 352,
  "24:27": 352,
  "24:28": 353,
  "24:29": 353,
  "24:30": 353,
  "24:31": 353,
  "24:32": 354,
  "24:33": 354,
  "24:34": 354,
  "24:35": 354,
  "24:36": 354,
  "24:37": 355,
  "24:38": 355,
  "24:39": 355,
  "24:40": 355,
  "24:41": 355,
  "24:42": 355,
  "24:43": 355,
  "24:44": 356,
  "24:45": 356,
  "24:46": 356,
  "24:47": 356,
  "24:48": 356,
  "24:49": 356,
  "24:50": 356,
  "24:51": 356,
  "24:52": 356,
  "24:53": 356,
  "24:54": 357,
  "24:55": 357,
  "24:56": 357,
  "24:57": 357,
  "24:58": 357,
  "24:59": 358,
  "24:60": 358,
  "24:61": 358,
  "24:62": 359,
  "24:63": 359,
  "24:64": 359,
  "25:1": 359,
  "25:2": 359,
  "25:3": 360,
  "25:4": 360,
  "25:5": 360,
  "25:6": 360,
  "25:7": 360,
  "25:8": 360,
  "25:9": 360,
  "25:10": 360,
  "25:11": 360,
  "25:12": 361,
  "25:13": 361,
  "25:14": 361,
  "25:15": 361,
  "25:16": 361,
  "25:17": 361,
  "25:18": 361,
  "25:19": 361,
  "25:20": 361,
  "25:21": 362,
  "25:22": 362,
  "25:23": 362,
  "25:24": 362,
  "25:25": 362,
  "25:26": 362,
  "25:27": 362,
  "25:28": 362,
  "25:29": 362,
  "25:30": 362,
  "25:31": 362,
  "25:32": 362,
  "25:33": 363,
  "25:34": 363,
  "25:35": 363,
  "25:36": 363,
  "25:37": 363,
  "25:38": 363,
  "25:39": 363,
  "25:40": 363,
  "25:41": 363,
  "25:42": 363,
  "25:43": 363,
  "25:44": 364,
  "25:45": 364,
  "25:46": 364,
  "25:47": 364,
  "25:48": 364,
  "25:49": 364,
  "25:50": 364,
  "25:51": 364,
  "25:52": 364,
  "25:53": 364,
  "25:54": 364,
  "25:55": 364,
  "25:56": 365,
  "25:57": 365,
  "25:58": 365,
  "25:59": 365,
  "25:60": 365,
  "25:61": 365,
  "25:62": 365,
  "25:63": 365,
  "25:64": 365,
  "25:65": 365,
  "25:66": 365,
  "25:67": 365,
  "25:68": 366,
  "25:69": 366,
  "25:70": 366,
  "25:71": 366,
  "25:72": 366,
  "25:73": 366,
  "25:74": 366,
  "25:75": 366,
  "25:76": 366,
  "25:77": 366,
  "26:1": 367,
  "26:2": 367,
  "26:3": 367,
  "26:4": 367,
  "26:5": 367,
  "26:6": 367,
  "26:7": 367,
  "26:8": 367,
  "26:9": 367,
  "26:10": 367,
  "26:11": 367,
  "26:12": 367,
  "26:13": 367,
  "26:14": 367,
  "26:15": 367,
  "26:16": 367,
  "26:17": 367,
  "26:18": 367,
  "26:19": 367,
  "26:20": 368,
  "26:21": 368,
  "26:22": 368,
  "26:23": 368,
  "26:24": 368,
  "26:25": 368,
  "26:26": 368,
  "26:27": 368,
  "26:28": 368,
  "26:29": 368,
  "26:30": 368,
  "26:31": 368,
  "26:32": 368,
  "26:33": 368,
  "26:34": 368,
  "26:35": 368,
  "26:36": 368,
  "26:37": 368,
  "26:38": 368,
  "26:39": 368,
  "26:40": 369,
  "26:41": 369,
  "26:42": 369,
  "26:43": 369,
  "26:44": 369,
  "26:45": 369,
  "26:46": 369,
  "26:47": 369,
  "26:48": 369,
  "26:49": 369,
  "26:50": 369,
  "26:51": 369,
  "26:52": 369,
  "26:53": 369,
  "26:54": 369,
  "26:55": 369,
  "26:56": 369,
  "26:57": 369,
  "26:58": 369,
  "26:59": 369,
  "26:60": 369,
  "26:61": 370,
  "26:62": 370,
  "26:63": 370,
  "26:64": 370,
  "26:65": 370,
  "26:66": 370,
  "26:67": 370,
  "26:68": 370,
  "26:69": 370,
  "26:70": 370,
  "26:71": 370,
  "26:72": 370,
  "26:73": 370,
  "26:74": 370,
  "26:75": 370,
  "26:76": 370,
  "26:77": 370,
  "26:78": 370,
  "26:79": 370,
  "26:80": 370,
  "26:81": 370,
  "26:82": 370,
  "26:83": 370,
  "26:84": 371,
  "26:85": 371,
  "26:86": 371,
  "26:87": 371,
  "26:88": 371,
  "26:89": 371,
  "26:90": 371,
  "26:91": 371,
  "26:92": 371,
  "26:93": 371,
  "26:94": 371,
  "26:95": 371,
  "26:96": 371,
  "26:97": 371,
  "26:98": 371,
  "26:99": 371,
  "26:100": 371,
  "26:101": 371,
  "26:102": 371,
  "26:103": 371,
  "26:104": 371,
  "26:105": 371,
  "26:106": 371,
  "26:107": 371,
  "26:108": 371,
  "26:109": 371,
  "26:110": 371,
  "26:111": 371,
  "26:112": 372,
  "26:113": 372,
  "26:114": 372,
  "26:115": 372,
  "26:116": 372,
  "26:117": 372,
  "26:118": 372,
  "26:119": 372,
  "26:120": 372,
  "26:121": 372,
  "26:122": 372,
  "26:123": 372,
  "26:124": 372,
  "26:125": 372,
  "26:126": 372,
  "26:127": 372,
  "26:128": 372,
  "26:129": 372,
  "26:130": 372,
  "26:131": 372,
  "26:132": 372,
  "26:133": 372,
  "26:134": 372,
  "26:135": 372,
  "26:136": 372,
  "26:137": 373,
  "26:138": 373,
  "26:139": 373,
  "26:140": 373,
  "26:141": 373,
  "26:142": 373,
  "26:143": 373,
  "26:144": 373,
  "26:145": 373,
  "26:146": 373,
  "26:147": 373,
  "26:148": 373,
  "26:149": 373,
  "26:150": 373,
  "26:151": 373,
  "26:152": 373,
  "26:153": 373,
  "26:154": 373,
  "26:155": 373,
  "26:156": 373,
  "26:157": 373,
  "26:158": 373,
  "26:159": 373,
  "26:160": 374,
  "26:161": 374,
  "26:162": 374,
  "26:163": 374,
  "26:164": 374,
  "26:165": 374,
  "26:166": 374,
  "26:167": 374,
  "26:168": 374,
  "26:169": 374,
  "26:170": 374,
  "26:171": 374,
  "26:172": 374,
  "26:173": 374,
  "26:174": 374,
  "26:175": 374,
  "26:176": 374,
  "26:177": 374,
  "26:178": 374,
  "26:179": 374,
  "26:180": 374,
  "26:181": 374,
  "26:182": 374,
  "26:183": 374,
  "26:184": 375,
  "26:185": 375,
  "26:186": 375,
  "26:187": 375,
  "26:188": 375,
  "26:189": 375,
  "26:190": 375,
  "26:191": 375,
  "26:192": 375,
  "26:193": 375,
  "26:194": 375,
  "26:195": 375,
  "26:196": 375,
  "26:197": 375,
  "26:198": 375,
  "26:199": 375,
  "26:200": 375,
  "26:201": 375,
  "26:202": 375,
  "26:203": 375,
  "26:204": 375,
  "26:205": 375,
  "26:206": 375,
  "26:207": 376,
  "26:208": 376,
  "26:209": 376,
  "26:210": 376,
  "26:211": 376,
  "26:212": 376,
  "26:213": 376,
  "26:214": 376,
  "26:215": 376,
  "26:216": 376,
  "26:217": 376,
  "26:218": 376,
  "26:219": 376,
  "26:220": 376,
  "26:221": 376,
  "26:222": 376,
  "26:223": 376,
  "26:224": 376,
  "26:225": 376,
  "26:226": 376,
  "26:227": 376,
  "27:1": 377,
  "27:2": 377,
  "27:3": 377,
  "27:4": 377,
  "27:5": 377,
  "27:6": 377,
  "27:7": 377,
  "27:8": 377,
  "27:9": 377,
  "27:10": 377,
  "27:11": 377,
  "27:12": 377,
  "27:13": 377,
  "27:14": 378,
  "27:15": 378,
  "27:16": 378,
  "27:17": 378,
  "27:18": 378,
  "27:19": 378,
  "27:20": 378,
  "27:21": 378,
  "27:22": 378,
  "27:23": 379,
  "27:24": 379,
  "27:25": 379,
  "27:26": 379,
  "27:27": 379,
  "27:28": 379,
  "27:29": 379,
  "27:30": 379,
  "27:31": 379,
  "27:32": 379,
  "27:33": 379,
  "27:34": 379,
  "27:35": 379,
  "27:36": 380,
  "27:37": 380,
  "27:38": 380,
  "27:39": 380,
  "27:40": 380,
  "27:41": 380,
  "27:42": 380,
  "27:43": 380,
  "27:44": 380,
  "27:45": 381,
  "27:46": 381,
  "27:47": 381,
  "27:48": 381,
  "27:49": 381,
  "27:50": 381,
  "27:51": 381,
  "27:52": 381,
  "27:53": 381,
  "27:54": 381,
  "27:55": 381,
  "27:56": 382,
  "27:57": 382,
  "27:58": 382,
  "27:59": 382,
  "27:60": 382,
  "27:61": 382,
  "27:62": 382,
  "27:63": 382,
  "27:64": 383,
  "27:65": 383,
  "27:66": 383,
  "27:67": 383,
  "27:68": 383,
  "27:69": 383,
  "27:70": 383,
  "27:71": 383,
  "27:72": 383,
  "27:73": 383,
  "27:74": 383,
  "27:75": 383,
  "27:76": 383,
  "27:77": 384,
  "27:78": 384,
  "27:79": 384,
  "27:80": 384,
  "27:81": 384,
  "27:82": 384,
  "27:83": 384,
  "27:84": 384,
  "27:85": 384,
  "27:86": 384,
  "27:87": 384,
  "27:88": 384,
  "27:89": 385,
  "27:90": 385,
  "27:91": 385,
  "27:92": 385,
  "27:93": 385,
  "28:1": 385,
  "28:2": 385,
  "28:3": 385,
  "28:4": 385,
  "28:5": 385,
  "28:6": 386,
  "28:7": 386,
  "28:8": 386,
  "28:9": 386,
  "28:10": 386,
  "28:11": 386,
  "28:12": 386,
  "28:13": 386,
  "28:14": 387,
  "28:15": 387,
  "28:16": 387,
  "28:17": 387,
  "28:18": 387,
  "28:19": 387,
  "28:20": 387,
  "28:21": 387,
  "28:22": 388,
  "28:23": 388,
  "28:24": 388,
  "28:25": 388,
  "28:26": 388,
  "28:27": 388,
  "28:28": 388,
  "28:29": 389,
  "28:30": 389,
  "28:31": 389,
  "28:32": 389,
  "28:33": 389,
  "28:34": 389,
  "28:35": 389,
  "28:36": 390,
  "28:37": 390,
  "28:38": 390,
  "28:39": 390,
  "28:40": 390,
  "28:41": 390,
  "28:42": 390,
  "28:43": 390,
  "28:44": 391,
  "28:45": 391,
  "28:46": 391,
  "28:47": 391,
  "28:48": 391,
  "28:49": 391,
  "28:50": 391,
  "28:51": 392,
  "28:52": 392,
  "28:53": 392,
  "28:54": 392,
  "28:55": 392,
  "28:56": 392,
  "28:57": 392,
  "28:58": 392,
  "28:59": 392,
  "28:60": 393,
  "28:61": 393,
  "28:62": 393,
  "28:63": 393,
  "28:64": 393,
  "28:65": 393,
  "28:66": 393,
  "28:67": 393,
  "28:68": 393,
  "28:69": 393,
  "28:70": 393,
  "28:71": 394,
  "28:72": 394,
  "28:73": 394,
  "28:74": 394,
  "28:75": 394,
  "28:76": 394,
  "28:77": 394,
  "28:78": 395,
  "28:79": 395,
  "28:80": 395,
  "28:81": 395,
  "28:82": 395,
  "28:83": 395,
  "28:84": 395,
  "28:85": 396,
  "28:86": 396,
  "28:87": 396,
  "28:88": 396,
  "29:1": 396,
  "29:2": 396,
  "29:3": 396,
  "29:4": 396,
  "29:5": 396,
  "29:6": 396,
  "29:7": 397,
  "29:8": 397,
  "29:9": 397,
  "29:10": 397,
  "29:11": 397,
  "29:12": 397,
  "29:13": 397,
  "29:14": 397,
  "29:15": 398,
  "29:16": 398,
  "29:17": 398,
  "29:18": 398,
  "29:19": 398,
  "29:20": 398,
  "29:21": 398,
  "29:22": 398,
  "29:23": 398,
  "29:24": 399,
  "29:25": 399,
  "29:26": 399,
  "29:27": 399,
  "29:28": 399,
  "29:29": 399,
  "29:30": 399,
  "29:31": 400,
  "29:32": 400,
  "29:33": 400,
  "29:34": 400,
  "29:35": 400,
  "29:36": 400,
  "29:37": 400,
  "29:38": 400,
  "29:39": 401,
  "29:40": 401,
  "29:41": 401,
  "29:42": 401,
  "29:43": 401,
  "29:44": 401,
  "29:45": 401,
  "29:46": 402,
  "29:47": 402,
  "29:48": 402,
  "29:49": 402,
  "29:50": 402,
  "29:51": 402,
  "29:52": 402,
  "29:53": 403,
  "29:54": 403,
  "29:55": 403,
  "29:56": 403,
  "29:57": 403,
  "29:58": 403,
  "29:59": 403,
  "29:60": 403,
  "29:61": 403,
  "29:62": 403,
  "29:63": 403,
  "29:64": 404,
  "29:65": 404,
  "29:66": 404,
  "29:67": 404,
  "29:68": 404,
  "29:69": 404,
  "30:1": 404,
  "30:2": 404,
  "30:3": 404,
  "30:4": 404,
  "30:5": 404,
  "30:6": 405,
  "30:7": 405,
  "30:8": 405,
  "30:9": 405,
  "30:10": 405,
  "30:11": 405,
  "30:12": 405,
  "30:13": 405,
  "30:14": 405,
  "30:15": 405,
  "30:16": 406,
  "30:17": 406,
  "30:18": 406,
  "30:19": 406,
  "30:20": 406,
  "30:21": 406,
  "30:22": 406,
  "30:23": 406,
  "30:24": 406,
  "30:25": 407,
  "30:26": 407,
  "30:27": 407,
  "30:28": 407,
  "30:29": 407,
  "30:30": 407,
  "30:31": 407,
  "30:32": 407,
  "30:33": 408,
  "30:34": 408,
  "30:35": 408,
  "30:36": 408,
  "30:37": 408,
  "30:38": 408,
  "30:39": 408,
  "30:40": 408,
  "30:41": 408,
  "30:42": 409,
  "30:43": 409,
  "30:44": 409,
  "30:45": 409,
  "30:46": 409,
  "30:47": 409,
  "30:48": 409,
  "30:49": 409,
  "30:50": 409,
  "30:51": 410,
  "30:52": 410,
  "30:53": 410,
  "30:54": 410,
  "30:55": 410,
  "30:56": 410,
  "30:57": 410,
  "30:58": 410,
  "30:59": 410,
  "30:60": 410,
  "31:1": 411,
  "31:2": 411,
  "31:3": 411,
  "31:4": 411,
  "31:5": 411,
  "31:6": 411,
  "31:7": 411,
  "31:8": 411,
  "31:9": 411,
  "31:10": 411,
  "31:11": 411,
  "31:12": 412,
  "31:13": 412,
  "31:14": 412,
  "31:15": 412,
  "31:16": 412,
  "31:17": 412,
  "31:18": 412,
  "31:19": 412,
  "31:20": 413,
  "31:21": 413,
  "31:22": 413,
  "31:23": 413,
  "31:24": 413,
  "31:25": 413,
  "31:26": 413,
  "31:27": 413,
  "31:28": 413,
  "31:29": 414,
  "31:30": 414,
  "31:31": 414,
  "31:32": 414,
  "31:33": 414,
  "31:34": 414,
  "32:1": 415,
  "32:2": 415,
  "32:3": 415,
  "32:4": 415,
  "32:5": 415,
  "32:6": 415,
  "32:7": 415,
  "32:8": 415,
  "32:9": 415,
  "32:10": 415,
  "32:11": 415,
  "32:12": 416,
  "32:13": 416,
  "32:14": 416,
  "32:15": 416,
  "32:16": 416,
  "32:17": 416,
  "32:18": 416,
  "32:19": 416,
  "32:20": 416,
  "32:21": 417,
  "32:22": 417,
  "32:23": 417,
  "32:24": 417,
  "32:25": 417,
  "32:26": 417,
  "32:27": 417,
  "32:28": 417,
  "32:29": 417,
  "32:30": 417,
  "33:1": 418,
  "33:2": 418,
  "33:3": 418,
  "33:4": 418,
  "33:5": 418,
  "33:6": 418,
  "33:7": 419,
  "33:8": 419,
  "33:9": 419,
  "33:10": 419,
  "33:11": 419,
  "33:12": 419,
  "33:13": 419,
  "33:14": 419,
  "33:15": 419,
  "33:16": 420,
  "33:17": 420,
  "33:18": 420,
  "33:19": 420,
  "33:20": 420,
  "33:21": 420,
  "33:22": 420,
  "33:23": 421,
  "33:24": 421,
  "33:25": 421,
  "33:26": 421,
  "33:27": 421,
  "33:28": 421,
  "33:29": 421,
  "33:30": 421,
  "33:31": 422,
  "33:32": 422,
  "33:33": 422,
  "33:34": 422,
  "33:35": 422,
  "33:36": 423,
  "33:37": 423,
  "33:38": 423,
  "33:39": 423,
  "33:40": 423,
  "33:41": 423,
  "33:42": 423,
  "33:43": 423,
  "33:44": 424,
  "33:45": 424,
  "33:46": 424,
  "33:47": 424,
  "33:48": 424,
  "33:49": 424,
  "33:50": 424,
  "33:51": 425,
  "33:52": 425,
  "33:53": 425,
  "33:54": 425,
  "33:55": 426,
  "33:56": 426,
  "33:57": 426,
  "33:58": 426,
  "33:59": 426,
  "33:60": 426,
  "33:61": 426,
  "33:62": 426,
  "33:63": 427,
  "33:64": 427,
  "33:65": 427,
  "33:66": 427,
  "33:67": 427,
  "33:68": 427,
  "33:69": 427,
  "33:70": 427,
  "33:71": 427,
  "33:72": 427,
  "33:73": 427,
  "34:1": 428,
  "34:2": 428,
  "34:3": 428,
  "34:4": 428,
  "34:5": 428,
  "34:6": 428,
  "34:7": 428,
  "34:8": 429,
  "34:9": 429,
  "34:10": 429,
  "34:11": 429,
  "34:12": 429,
  "34:13": 429,
  "34:14": 429,
  "34:15": 430,
  "34:16": 430,
  "34:17": 430,
  "34:18": 430,
  "34:19": 430,
  "34:20": 430,
  "34:21": 430,
  "34:22": 430,
  "34:23": 431,
  "34:24": 431,
  "34:25": 431,
  "34:26": 431,
  "34:27": 431,
  "34:28": 431,
  "34:29": 431,
  "34:30": 431,
  "34:31": 431,
  "34:32": 432,
  "34:33": 432,
  "34:34": 432,
  "34:35": 432,
  "34:36": 432,
  "34:37": 432,
  "34:38": 432,
  "34:39": 432,
  "34:40": 433,
  "34:41": 433,
  "34:42": 433,
  "34:43": 433,
  "34:44": 433,
  "34:45": 433,
  "34:46": 433,
  "34:47": 433,
  "34:48": 433,
  "34:49": 434,
  "34:50": 434,
  "34:51": 434,
  "34:52": 434,
  "34:53": 434,
  "34:54": 434,
  "35:1": 434,
  "35:2": 434,
  "35:3": 434,
  "35:4": 435,
  "35:5": 435,
  "35:6": 435,
  "35:7": 435,
  "35:8": 435,
  "35:9": 435,
  "35:10": 435,
  "35:11": 435,
  "35:12": 436,
  "35:13": 436,
  "35:14": 436,
  "35:15": 436,
  "35:16": 436,
  "35:17": 436,
  "35:18": 436,
  "35:19": 437,
  "35:20": 437,
  "35:21": 437,
  "35:22": 437,
  "35:23": 437,
  "35:24": 437,
  "35:25": 437,
  "35:26": 437,
  "35:27": 437,
  "35:28": 437,
  "35:29": 437,
  "35:30": 437,
  "35:31": 438,
  "35:32": 438,
  "35:33": 438,
  "35:34": 438,
  "35:35": 438,
  "35:36": 438,
  "35:37": 438,
  "35:38": 438,
  "35:39": 439,
  "35:40": 439,
  "35:41": 439,
  "35:42": 439,
  "35:43": 439,
  "35:44": 439,
  "35:45": 440,
  "36:1": 440,
  "36:2": 440,
  "36:3": 440,
  "36:4": 440,
  "36:5": 440,
  "36:6": 440,
  "36:7": 440,
  "36:8": 440,
  "36:9": 440,
  "36:10": 440,
  "36:11": 440,
  "36:12": 440,
  "36:13": 441,
  "36:14": 441,
  "36:15": 441,
  "36:16": 441,
  "36:17": 441,
  "36:18": 441,
  "36:19": 441,
  "36:20": 441,
  "36:21": 441,
  "36:22": 441,
  "36:23": 441,
  "36:24": 441,
  "36:25": 441,
  "36:26": 441,
  "36:27": 441,
  "36:28": 442,
  "36:29": 442,
  "36:30": 442,
  "36:31": 442,
  "36:32": 442,
  "36:33": 442,
  "36:34": 442,
  "36:35": 442,
  "36:36": 442,
  "36:37": 442,
  "36:38": 442,
  "36:39": 442,
  "36:40": 442,
  "36:41": 443,
  "36:42": 443,
  "36:43": 443,
  "36:44": 443,
  "36:45": 443,
  "36:46": 443,
  "36:47": 443,
  "36:48": 443,
  "36:49": 443,
  "36:50": 443,
  "36:51": 443,
  "36:52": 443,
  "36:53": 443,
  "36:54": 443,
  "36:55": 444,
  "36:56": 444,
  "36:57": 444,
  "36:58": 444,
  "36:59": 444,
  "36:60": 444,
  "36:61": 444,
  "36:62": 444,
  "36:63": 444,
  "36:64": 444,
  "36:65": 444,
  "36:66": 444,
  "36:67": 444,
  "36:68": 444,
  "36:69": 444,
  "36:70": 444,
  "36:71": 445,
  "36:72": 445,
  "36:73": 445,
  "36:74": 445,
  "36:75": 445,
  "36:76": 445,
  "36:77": 445,
  "36:78": 445,
  "36:79": 445,
  "36:80": 445,
  "36:81": 445,
  "36:82": 445,
  "36:83": 445,
  "37:1": 446,
  "37:2": 446,
  "37:3": 446,
  "37:4": 446,
  "37:5": 446,
  "37:6": 446,
  "37:7": 446,
  "37:8": 446,
  "37:9": 446,
  "37:10": 446,
  "37:11": 446,
  "37:12": 446,
  "37:13": 446,
  "37:14": 446,
  "37:15": 446,
  "37:16": 446,
  "37:17": 446,
  "37:18": 446,
  "37:19": 446,
  "37:20": 446,
  "37:21": 446,
  "37:22": 446,
  "37:23": 446,
  "37:24": 446,
  "37:25": 447,
  "37:26": 447,
  "37:27": 447,
  "37:28": 447,
  "37:29": 447,
  "37:30": 447,
  "37:31": 447,
  "37:32": 447,
  "37:33": 447,
  "37:34": 447,
  "37:35": 447,
  "37:36": 447,
  "37:37": 447,
  "37:38": 447,
  "37:39": 447,
  "37:40": 447,
  "37:41": 447,
  "37:42": 447,
  "37:43": 447,
  "37:44": 447,
  "37:45": 447,
  "37:46": 447,
  "37:47": 447,
  "37:48": 447,
  "37:49": 447,
  "37:50": 447,
  "37:51": 447,
  "37:52": 448,
  "37:53": 448,
  "37:54": 448,
  "37:55": 448,
  "37:56": 448,
  "37:57": 448,
  "37:58": 448,
  "37:59": 448,
  "37:60": 448,
  "37:61": 448,
  "37:62": 448,
  "37:63": 448,
  "37:64": 448,
  "37:65": 448,
  "37:66": 448,
  "37:67": 448,
  "37:68": 448,
  "37:69": 448,
  "37:70": 448,
  "37:71": 448,
  "37:72": 448,
  "37:73": 448,
  "37:74": 448,
  "37:75": 448,
  "37:76": 448,
  "37:77": 449,
  "37:78": 449,
  "37:79": 449,
  "37:80": 449,
  "37:81": 449,
  "37:82": 449,
  "37:83": 449,
  "37:84": 449,
  "37:85": 449,
  "37:86": 449,
  "37:87": 449,
  "37:88": 449,
  "37:89": 449,
  "37:90": 449,
  "37:91": 449,
  "37:92": 449,
  "37:93": 449,
  "37:94": 449,
  "37:95": 449,
  "37:96": 449,
  "37:97": 449,
  "37:98": 449,
  "37:99": 449,
  "37:100": 449,
  "37:101": 449,
  "37:102": 449,
  "37:103": 450,
  "37:104": 450,
  "37:105": 450,
  "37:106": 450,
  "37:107": 450,
  "37:108": 450,
  "37:109": 450,
  "37:110": 450,
  "37:111": 450,
  "37:112": 450,
  "37:113": 450,
  "37:114": 450,
  "37:115": 450,
  "37:116": 450,
  "37:117": 450,
  "37:118": 450,
  "37:119": 450,
  "37:120": 450,
  "37:121": 450,
  "37:122": 450,
  "37:123": 450,
  "37:124": 450,
  "37:125": 450,
  "37:126": 450,
  "37:127": 451,
  "37:128": 451,
  "37:129": 451,
  "37:130": 451,
  "37:131": 451,
  "37:132": 451,
  "37:133": 451,
  "37:134": 451,
  "37:135": 451,
  "37:136": 451,
  "37:137": 451,
  "37:138": 451,
  "37:139": 451,
  "37:140": 451,
  "37:141": 451,
  "37:142": 451,
  "37:143": 451,
  "37:144": 451,
  "37:145": 451,
  "37:146": 451,
  "37:147": 451,
  "37:148": 451,
  "37:149": 451,
  "37:150": 451,
  "37:151": 451,
  "37:152": 451,
  "37:153": 451,
  "37:154": 452,
  "37:155": 452,
  "37:156": 452,
  "37:157": 452,
  "37:158": 452,
  "37:159": 452,
  "37:160": 452,
  "37:161": 452,
  "37:162": 452,
  "37:163": 452,
  "37:164": 452,
  "37:165": 452,
  "37:166": 452,
  "37:167": 452,
  "37:168": 452,
  "37:169": 452,
  "37:170": 452,
  "37:171": 452,
  "37:172": 452,
  "37:173": 452,
  "37:174": 452,
  "37:175": 452,
  "37:176": 452,
  "37:177": 452,
  "37:178": 452,
  "37:179": 452,
  "37:180": 452,
  "37:181": 452,
  "37:182": 452,
  "38:1": 453,
  "38:2": 453,
  "38:3": 453,
  "38:4": 453,
  "38:5": 453,
  "38:6": 453,
  "38:7": 453,
  "38:8": 453,
  "38:9": 453,
  "38:10": 453,
  "38:11": 453,
  "38:12": 453,
  "38:13": 453,
  "38:14": 453,
  "38:15": 453,
  "38:16": 453,
  "38:17": 454,
  "38:18": 454,
  "38:19": 454,
  "38:20": 454,
  "38:21": 454,
  "38:22": 454,
  "38:23": 454,
  "38:24": 454,
  "38:25": 454,
  "38:26": 454,
  "38:27": 455,
  "38:28": 455,
  "38:29": 455,
  "38:30": 455,
  "38:31": 455,
  "38:32": 455,
  "38:33": 455,
  "38:34": 455,
  "38:35": 455,
  "38:36": 455,
  "38:37": 455,
  "38:38": 455,
  "38:39": 455,
  "38:40": 455,
  "38:41": 455,
  "38:42": 455,
  "38:43": 456,
  "38:44": 456,
  "38:45": 456,
  "38:46": 456,
  "38:47": 456,
  "38:48": 456,
  "38:49": 456,
  "38:50": 456,
  "38:51": 456,
  "38:52": 456,
  "38:53": 456,
  "38:54": 456,
  "38:55": 456,
  "38:56": 456,
  "38:57": 456,
  "38:58": 456,
  "38:59": 456,
  "38:60": 456,
  "38:61": 456,
  "38:62": 457,
  "38:63": 457,
  "38:64": 457,
  "38:65": 457,
  "38:66": 457,
  "38:67": 457,
  "38:68": 457,
  "38:69": 457,
  "38:70": 457,
  "38:71": 457,
  "38:72": 457,
  "38:73": 457,
  "38:74": 457,
  "38:75": 457,
  "38:76": 457,
  "38:77": 457,
  "38:78": 457,
  "38:79": 457,
  "38:80": 457,
  "38:81": 457,
  "38:82": 457,
  "38:83": 457,
  "38:84": 458,
  "38:85": 458,
  "38:86": 458,
  "38:87": 458,
  "38:88": 458,
  "39:1": 458,
  "39:2": 458,
  "39:3": 458,
  "39:4": 458,
  "39:5": 458,
  "39:6": 459,
  "39:7": 459,
  "39:8": 459,
  "39:9": 459,
  "39:10": 459,
  "39:11": 460,
  "39:12": 460,
  "39:13": 460,
  "39:14": 460,
  "39:15": 460,
  "39:16": 460,
  "39:17": 460,
  "39:18": 460,
  "39:19": 460,
  "39:20": 460,
  "39:21": 460,
  "39:22": 461,
  "39:23": 461,
  "39:24": 461,
  "39:25": 461,
  "39:26": 461,
  "39:27": 461,
  "39:28": 461,
  "39:29": 461,
  "39:30": 461,
  "39:31": 461,
  "39:32": 462,
  "39:33": 462,
  "39:34": 462,
  "39:35": 462,
  "39:36": 462,
  "39:37": 462,
  "39:38": 462,
  "39:39": 462,
  "39:40": 462,
  "39:41": 463,
  "39:42": 463,
  "39:43": 463,
  "39:44": 463,
  "39:45": 463,
  "39:46": 463,
  "39:47": 463,
  "39:48": 464,
  "39:49": 464,
  "39:50": 464,
  "39:51": 464,
  "39:52": 464,
  "39:53": 464,
  "39:54": 464,
  "39:55": 464,
  "39:56": 464,
  "39:57": 465,
  "39:58": 465,
  "39:59": 465,
  "39:60": 465,
  "39:61": 465,
  "39:62": 465,
  "39:63": 465,
  "39:64": 465,
  "39:65": 465,
  "39:66": 465,
  "39:67": 465,
  "39:68": 466,
  "39:69": 466,
  "39:70": 466,
  "39:71": 466,
  "39:72": 466,
  "39:73": 466,
  "39:74": 466,
  "39:75": 467,
  "40:1": 467,
  "40:2": 467,
  "40:3": 467,
  "40:4": 467,
  "40:5": 467,
  "40:6": 467,
  "40:7": 467,
  "40:8": 468,
  "40:9": 468,
  "40:10": 468,
  "40:11": 468,
  "40:12": 468,
  "40:13": 468,
  "40:14": 468,
  "40:15": 468,
  "40:16": 468,
  "40:17": 469,
  "40:18": 469,
  "40:19": 469,
  "40:20": 469,
  "40:21": 469,
  "40:22": 469,
  "40:23": 469,
  "40:24": 469,
  "40:25": 469,
  "40:26": 470,
  "40:27": 470,
  "40:28": 470,
  "40:29": 470,
  "40:30": 470,
  "40:31": 470,
  "40:32": 470,
  "40:33": 470,
  "40:34": 471,
  "40:35": 471,
  "40:36": 471,
  "40:37": 471,
  "40:38": 471,
  "40:39": 471,
  "40:40": 471,
  "40:41": 472,
  "40:42": 472,
  "40:43": 472,
  "40:44": 472,
  "40:45": 472,
  "40:46": 472,
  "40:47": 472,
  "40:48": 472,
  "40:49": 472,
  "40:50": 473,
  "40:51": 473,
  "40:52": 473,
  "40:53": 473,
  "40:54": 473,
  "40:55": 473,
  "40:56": 473,
  "40:57": 473,
  "40:58": 473,
  "40:59": 474,
  "40:60": 474,
  "40:61": 474,
  "40:62": 474,
  "40:63": 474,
  "40:64": 474,
  "40:65": 474,
  "40:66": 474,
  "40:67": 475,
  "40:68": 475,
  "40:69": 475,
  "40:70": 475,
  "40:71": 475,
  "40:72": 475,
  "40:73": 475,
  "40:74": 475,
  "40:75": 475,
  "40:76": 475,
  "40:77": 475,
  "40:78": 476,
  "40:79": 476,
  "40:80": 476,
  "40:81": 476,
  "40:82": 476,
  "40:83": 476,
  "40:84": 476,
  "40:85": 476,
  "41:1": 477,
  "41:2": 477,
  "41:3": 477,
  "41:4": 477,
  "41:5": 477,
  "41:6": 477,
  "41:7": 477,
  "41:8": 477,
  "41:9": 477,
  "41:10": 477,
  "41:11": 477,
  "41:12": 478,
  "41:13": 478,
  "41:14": 478,
  "41:15": 478,
  "41:16": 478,
  "41:17": 478,
  "41:18": 478,
  "41:19": 478,
  "41:20": 478,
  "41:21": 479,
  "41:22": 479,
  "41:23": 479,
  "41:24": 479,
  "41:25": 479,
  "41:26": 479,
  "41:27": 479,
  "41:28": 479,
  "41:29": 479,
  "41:30": 480,
  "41:31": 480,
  "41:32": 480,
  "41:33": 480,
  "41:34": 480,
  "41:35": 480,
  "41:36": 480,
  "41:37": 480,
  "41:38": 480,
  "41:39": 481,
  "41:40": 481,
  "41:41": 481,
  "41:42": 481,
  "41:43": 481,
  "41:44": 481,
  "41:45": 481,
  "41:46": 481,
  "41:47": 482,
  "41:48": 482,
  "41:49": 482,
  "41:50": 482,
  "41:51": 482,
  "41:52": 482,
  "41:53": 482,
  "41:54": 482,
  "42:1": 483,
  "42:2": 483,
  "42:3": 483,
  "42:4": 483,
  "42:5": 483,
  "42:6": 483,
  "42:7": 483,
  "42:8": 483,
  "42:9": 483,
  "42:10": 483,
  "42:11": 484,
  "42:12": 484,
  "42:13": 484,
  "42:14": 484,
  "42:15": 484,
  "42:16": 485,
  "42:17": 485,
  "42:18": 485,
  "42:19": 485,
  "42:20": 485,
  "42:21": 485,
  "42:22": 485,
  "42:23": 486,
  "42:24": 486,
  "42:25": 486,
  "42:26": 486,
  "42:27": 486,
  "42:28": 486,
  "42:29": 486,
  "42:30": 486,
  "42:31": 486,
  "42:32": 487,
  "42:33": 487,
  "42:34": 487,
  "42:35": 487,
  "42:36": 487,
  "42:37": 487,
  "42:38": 487,
  "42:39": 487,
  "42:40": 487,
  "42:41": 487,
  "42:42": 487,
  "42:43": 487,
  "42:44": 487,
  "42:45": 488,
  "42:46": 488,
  "42:47": 488,
  "42:48": 488,
  "42:49": 488,
  "42:50": 488,
  "42:51": 488,
  "42:52": 489,
  "42:53": 489,
  "43:1": 489,
  "43:2": 489,
  "43:3": 489,
  "43:4": 489,
  "43:5": 489,
  "43:6": 489,
  "43:7": 489,
  "43:8": 489,
  "43:9": 489,
  "43:10": 489,
  "43:11": 490,
  "43:12": 490,
  "43:13": 490,
  "43:14": 490,
  "43:15": 490,
  "43:16": 490,
  "43:17": 490,
  "43:18": 490,
  "43:19": 490,
  "43:20": 490,
  "43:21": 490,
  "43:22": 490,
  "43:23": 491,
  "43:24": 491,
  "43:25": 491,
  "43:26": 491,
  "43:27": 491,
  "43:28": 491,
  "43:29": 491,
  "43:30": 491,
  "43:31": 491,
  "43:32": 491,
  "43:33": 491,
  "43:34": 492,
  "43:35": 492,
  "43:36": 492,
  "43:37": 492,
  "43:38": 492,
  "43:39": 492,
  "43:40": 492,
  "43:41": 492,
  "43:42": 492,
  "43:43": 492,
  "43:44": 492,
  "43:45": 492,
  "43:46": 492,
  "43:47": 492,
  "43:48": 493,
  "43:49": 493,
  "43:50": 493,
  "43:51": 493,
  "43:52": 493,
  "43:53": 493,
  "43:54": 493,
  "43:55": 493,
  "43:56": 493,
  "43:57": 493,
  "43:58": 493,
  "43:59": 493,
  "43:60": 493,
  "43:61": 494,
  "43:62": 494,
  "43:63": 494,
  "43:64": 494,
  "43:65": 494,
  "43:66": 494,
  "43:67": 494,
  "43:68": 494,
  "43:69": 494,
  "43:70": 494,
  "43:71": 494,
  "43:72": 494,
  "43:73": 494,
  "43:74": 495,
  "43:75": 495,
  "43:76": 495,
  "43:77": 495,
  "43:78": 495,
  "43:79": 495,
  "43:80": 495,
  "43:81": 495,
  "43:82": 495,
  "43:83": 495,
  "43:84": 495,
  "43:85": 495,
  "43:86": 495,
  "43:87": 495,
  "43:88": 495,
  "43:89": 495,
  "44:1": 496,
  "44:2": 496,
  "44:3": 496,
  "44:4": 496,
  "44:5": 496,
  "44:6": 496,
  "44:7": 496,
  "44:8": 496,
  "44:9": 496,
  "44:10": 496,
  "44:11": 496,
  "44:12": 496,
  "44:13": 496,
  "44:14": 496,
  "44:15": 496,
  "44:16": 496,
  "44:17": 496,
  "44:18": 496,
  "44:19": 497,
  "44:20": 497,
  "44:21": 497,
  "44:22": 497,
  "44:23": 497,
  "44:24": 497,
  "44:25": 497,
  "44:26": 497,
  "44:27": 497,
  "44:28": 497,
  "44:29": 497,
  "44:30": 497,
  "44:31": 497,
  "44:32": 497,
  "44:33": 497,
  "44:34": 497,
  "44:35": 497,
  "44:36": 497,
  "44:37": 497,
  "44:38": 497,
  "44:39": 497,
  "44:40": 498,
  "44:41": 498,
  "44:42": 498,
  "44:43": 498,
  "44:44": 498,
  "44:45": 498,
  "44:46": 498,
  "44:47": 498,
  "44:48": 498,
  "44:49": 498,
  "44:50": 498,
  "44:51": 498,
  "44:52": 498,
  "44:53": 498,
  "44:54": 498,
  "44:55": 498,
  "44:56": 498,
  "44:57": 498,
  "44:58": 498,
  "44:59": 498,
  "45:1": 499,
  "45:2": 499,
  "45:3": 499,
  "45:4": 499,
  "45:5": 499,
  "45:6": 499,
  "45:7": 499,
  "45:8": 499,
  "45:9": 499,
  "45:10": 499,
  "45:11": 499,
  "45:12": 499,
  "45:13": 499,
  "45:14": 500,
  "45:15": 500,
  "45:16": 500,
  "45:17": 500,
  "45:18": 500,
  "45:19": 500,
  "45:20": 500,
  "45:21": 500,
  "45:22": 500,
  "45:23": 501,
  "45:24": 501,
  "45:25": 501,
  "45:26": 501,
  "45:27": 501,
  "45:28": 501,
  "45:29": 501,
  "45:30": 501,
  "45:31": 501,
  "45:32": 501,
  "45:33": 502,
  "45:34": 502,
  "45:35": 502,
  "45:36": 502,
  "45:37": 502,
  "46:1": 502,
  "46:2": 502,
  "46:3": 502,
  "46:4": 502,
  "46:5": 502,
  "46:6": 503,
  "46:7": 503,
  "46:8": 503,
  "46:9": 503,
  "46:10": 503,
  "46:11": 503,
  "46:12": 503,
  "46:13": 503,
  "46:14": 503,
  "46:15": 504,
  "46:16": 504,
  "46:17": 504,
  "46:18": 504,
  "46:19": 504,
  "46:20": 504,
  "46:21": 505,
  "46:22": 505,
  "46:23": 505,
  "46:24": 505,
  "46:25": 505,
  "46:26": 505,
  "46:27": 505,
  "46:28": 505,
  "46:29": 506,
  "46:30": 506,
  "46:31": 506,
  "46:32": 506,
  "46:33": 506,
  "46:34": 506,
  "46:35": 506,
  "47:1": 507,
  "47:2": 507,
  "47:3": 507,
  "47:4": 507,
  "47:5": 507,
  "47:6": 507,
  "47:7": 507,
  "47:8": 507,
  "47:9": 507,
  "47:10": 507,
  "47:11": 507,
  "47:12": 508,
  "47:13": 508,
  "47:14": 508,
  "47:15": 508,
  "47:16": 508,
  "47:17": 508,
  "47:18": 508,
  "47:19": 508,
  "47:20": 509,
  "47:21": 509,
  "47:22": 509,
  "47:23": 509,
  "47:24": 509,
  "47:25": 509,
  "47:26": 509,
  "47:27": 509,
  "47:28": 509,
  "47:29": 509,
  "47:30": 510,
  "47:31": 510,
  "47:32": 510,
  "47:33": 510,
  "47:34": 510,
  "47:35": 510,
  "47:36": 510,
  "47:37": 510,
  "47:38": 510,
  "48:1": 511,
  "48:2": 511,
  "48:3": 511,
  "48:4": 511,
  "48:5": 511,
  "48:6": 511,
  "48:7": 511,
  "48:8": 511,
  "48:9": 511,
  "48:10": 512,
  "48:11": 512,
  "48:12": 512,
  "48:13": 512,
  "48:14": 512,
  "48:15": 512,
  "48:16": 513,
  "48:17": 513,
  "48:18": 513,
  "48:19": 513,
  "48:20": 513,
  "48:21": 513,
  "48:22": 513,
  "48:23": 513,
  "48:24": 514,
  "48:25": 514,
  "48:26": 514,
  "48:27": 514,
  "48:28": 514,
  "48:29": 515,
  "49:1": 515,
  "49:2": 515,
  "49:3": 515,
  "49:4": 515,
  "49:5": 516,
  "49:6": 516,
  "49:7": 516,
  "49:8": 516,
  "49:9": 516,
  "49:10": 516,
  "49:11": 516,
  "49:12": 517,
  "49:13": 517,
  "49:14": 517,
  "49:15": 517,
  "49:16": 517,
  "49:17": 517,
  "49:18": 517,
  "50:1": 518,
  "50:2": 518,
  "50:3": 518,
  "50:4": 518,
  "50:5": 518,
  "50:6": 518,
  "50:7": 518,
  "50:8": 518,
  "50:9": 518,
  "50:10": 518,
  "50:11": 518,
  "50:12": 518,
  "50:13": 518,
  "50:14": 518,
  "50:15": 518,
  "50:16": 519,
  "50:17": 519,
  "50:18": 519,
  "50:19": 519,
  "50:20": 519,
  "50:21": 519,
  "50:22": 519,
  "50:23": 519,
  "50:24": 519,
  "50:25": 519,
  "50:26": 519,
  "50:27": 519,
  "50:28": 519,
  "50:29": 519,
  "50:30": 519,
  "50:31": 519,
  "50:32": 519,
  "50:33": 519,
  "50:34": 519,
  "50:35": 519,
  "50:36": 520,
  "50:37": 520,
  "50:38": 520,
  "50:39": 520,
  "50:40": 520,
  "50:41": 520,
  "50:42": 520,
  "50:43": 520,
  "50:44": 520,
  "50:45": 520,
  "51:1": 520,
  "51:2": 520,
  "51:3": 520,
  "51:4": 520,
  "51:5": 520,
  "51:6": 520,
  "51:7": 521,
  "51:8": 521,
  "51:9": 521,
  "51:10": 521,
  "51:11": 521,
  "51:12": 521,
  "51:13": 521,
  "51:14": 521,
  "51:15": 521,
  "51:16": 521,
  "51:17": 521,
  "51:18": 521,
  "51:19": 521,
  "51:20": 521,
  "51:21": 521,
  "51:22": 521,
  "51:23": 521,
  "51:24": 521,
  "51:25": 521,
  "51:26": 521,
  "51:27": 521,
  "51:28": 521,
  "51:29": 521,
  "51:30": 521,
  "51:31": 522,
  "51:32": 522,
  "51:33": 522,
  "51:34": 522,
  "51:35": 522,
  "51:36": 522,
  "51:37": 522,
  "51:38": 522,
  "51:39": 522,
  "51:40": 522,
  "51:41": 522,
  "51:42": 522,
  "51:43": 522,
  "51:44": 522,
  "51:45": 522,
  "51:46": 522,
  "51:47": 522,
  "51:48": 522,
  "51:49": 522,
  "51:50": 522,
  "51:51": 522,
  "51:52": 523,
  "51:53": 523,
  "51:54": 523,
  "51:55": 523,
  "51:56": 523,
  "51:57": 523,
  "51:58": 523,
  "51:59": 523,
  "51:60": 523,
  "52:1": 523,
  "52:2": 523,
  "52:3": 523,
  "52:4": 523,
  "52:5": 523,
  "52:6": 523,
  "52:7": 523,
  "52:8": 523,
  "52:9": 523,
  "52:10": 523,
  "52:11": 523,
  "52:12": 523,
  "52:13": 523,
  "52:14": 523,
  "52:15": 524,
  "52:16": 524,
  "52:17": 524,
  "52:18": 524,
  "52:19": 524,
  "52:20": 524,
  "52:21": 524,
  "52:22": 524,
  "52:23": 524,
  "52:24": 524,
  "52:25": 524,
  "52:26": 524,
  "52:27": 524,
  "52:28": 524,
  "52:29": 524,
  "52:30": 524,
  "52:31": 524,
  "52:32": 525,
  "52:33": 525,
  "52:34": 525,
  "52:35": 525,
  "52:36": 525,
  "52:37": 525,
  "52:38": 525,
  "52:39": 525,
  "52:40": 525,
  "52:41": 525,
  "52:42": 525,
  "52:43": 525,
  "52:44": 525,
  "52:45": 525,
  "52:46": 525,
  "52:47": 525,
  "52:48": 525,
  "52:49": 525,
  "53:1": 526,
  "53:2": 526,
  "53:3": 526,
  "53:4": 526,
  "53:5": 526,
  "53:6": 526,
  "53:7": 526,
  "53:8": 526,
  "53:9": 526,
  "53:10": 526,
  "53:11": 526,
  "53:12": 526,
  "53:13": 526,
  "53:14": 526,
  "53:15": 526,
  "53:16": 526,
  "53:17": 526,
  "53:18": 526,
  "53:19": 526,
  "53:20": 526,
  "53:21": 526,
  "53:22": 526,
  "53:23": 526,
  "53:24": 526,
  "53:25": 526,
  "53:26": 526,
  "53:27": 527,
  "53:28": 527,
  "53:29": 527,
  "53:30": 527,
  "53:31": 527,
  "53:32": 527,
  "53:33": 527,
  "53:34": 527,
  "53:35": 527,
  "53:36": 527,
  "53:37": 527,
  "53:38": 527,
  "53:39": 527,
  "53:40": 527,
  "53:41": 527,
  "53:42": 527,
  "53:43": 527,
  "53:44": 527,
  "53:45": 528,
  "53:46": 528,
  "53:47": 528,
  "53:48": 528,
  "53:49": 528,
  "53:50": 528,
  "53:51": 528,
  "53:52": 528,
  "53:53": 528,
  "53:54": 528,
  "53:55": 528,
  "53:56": 528,
  "53:57": 528,
  "53:58": 528,
  "53:59": 528,
  "53:60": 528,
  "53:61": 528,
  "53:62": 528,
  "54:1": 528,
  "54:2": 528,
  "54:3": 528,
  "54:4": 528,
  "54:5": 528,
  "54:6": 528,
  "54:7": 529,
  "54:8": 529,
  "54:9": 529,
  "54:10": 529,
  "54:11": 529,
  "54:12": 529,
  "54:13": 529,
  "54:14": 529,
  "54:15": 529,
  "54:16": 529,
  "54:17": 529,
  "54:18": 529,
  "54:19": 529,
  "54:20": 529,
  "54:21": 529,
  "54:22": 529,
  "54:23": 529,
  "54:24": 529,
  "54:25": 529,
  "54:26": 529,
  "54:27": 529,
  "54:28": 530,
  "54:29": 530,
  "54:30": 530,
  "54:31": 530,
  "54:32": 530,
  "54:33": 530,
  "54:34": 530,
  "54:35": 530,
  "54:36": 530,
  "54:37": 530,
  "54:38": 530,
  "54:39": 530,
  "54:40": 530,
  "54:41": 530,
  "54:42": 530,
  "54:43": 530,
  "54:44": 530,
  "54:45": 530,
  "54:46": 530,
  "54:47": 530,
  "54:48": 530,
  "54:49": 530,
  "54:50": 531,
  "54:51": 531,
  "54:52": 531,
  "54:53": 531,
  "54:54": 531,
  "54:55": 531,
  "55:1": 531,
  "55:2": 531,
  "55:3": 531,
  "55:4": 531,
  "55:5": 531,
  "55:6": 531,
  "55:7": 531,
  "55:8": 531,
  "55:9": 531,
  "55:10": 531,
  "55:11": 531,
  "55:12": 531,
  "55:13": 531,
  "55:14": 531,
  "55:15": 531,
  "55:16": 531,
  "55:17": 532,
  "55:18": 532,
  "55:19": 532,
  "55:20": 532,
  "55:21": 532,
  "55:22": 532,
  "55:23": 532,
  "55:24": 532,
  "55:25": 532,
  "55:26": 532,
  "55:27": 532,
  "55:28": 532,
  "55:29": 532,
  "55:30": 532,
  "55:31": 532,
  "55:32": 532,
  "55:33": 532,
  "55:34": 532,
  "55:35": 532,
  "55:36": 532,
  "55:37": 532,
  "55:38": 532,
  "55:39": 532,
  "55:40": 532,
  "55:41": 533,
  "55:42": 533,
  "55:43": 533,
  "55:44": 533,
  "55:45": 533,
  "55:46": 533,
  "55:47": 533,
  "55:48": 533,
  "55:49": 533,
  "55:50": 533,
  "55:51": 533,
  "55:52": 533,
  "55:53": 533,
  "55:54": 533,
  "55:55": 533,
  "55:56": 533,
  "55:57": 533,
  "55:58": 533,
  "55:59": 533,
  "55:60": 533,
  "55:61": 533,
  "55:62": 533,
  "55:63": 533,
  "55:64": 533,
  "55:65": 533,
  "55:66": 533,
  "55:67": 533,
  "55:68": 534,
  "55:69": 534,
  "55:70": 534,
  "55:71": 534,
  "55:72": 534,
  "55:73": 534,
  "55:74": 534,
  "55:75": 534,
  "55:76": 534,
  "55:77": 534,
  "55:78": 534,
  "56:1": 534,
  "56:2": 534,
  "56:3": 534,
  "56:4": 534,
  "56:5": 534,
  "56:6": 534,
  "56:7": 534,
  "56:8": 534,
  "56:9": 534,
  "56:10": 534,
  "56:11": 534,
  "56:12": 534,
  "56:13": 534,
  "56:14": 534,
  "56:15": 534,
  "56:16": 534,
  "56:17": 535,
  "56:18": 535,
  "56:19": 535,
  "56:20": 535,
  "56:21": 535,
  "56:22": 535,
  "56:23": 535,
  "56:24": 535,
  "56:25": 535,
  "56:26": 535,
  "56:27": 535,
  "56:28": 535,
  "56:29": 535,
  "56:30": 535,
  "56:31": 535,
  "56:32": 535,
  "56:33": 535,
  "56:34": 535,
  "56:35": 535,
  "56:36": 535,
  "56:37": 535,
  "56:38": 535,
  "56:39": 535,
  "56:40": 535,
  "56:41": 535,
  "56:42": 535,
  "56:43": 535,
  "56:44": 535,
  "56:45": 535,
  "56:46": 535,
  "56:47": 535,
  "56:48": 535,
  "56:49": 535,
  "56:50": 535,
  "56:51": 536,
  "56:52": 536,
  "56:53": 536,
  "56:54": 536,
  "56:55": 536,
  "56:56": 536,
  "56:57": 536,
  "56:58": 536,
  "56:59": 536,
  "56:60": 536,
  "56:61": 536,
  "56:62": 536,
  "56:63": 536,
  "56:64": 536,
  "56:65": 536,
  "56:66": 536,
  "56:67": 536,
  "56:68": 536,
  "56:69": 536,
  "56:70": 536,
  "56:71": 536,
  "56:72": 536,
  "56:73": 536,
  "56:74": 536,
  "56:75": 536,
  "56:76": 536,
  "56:77": 537,
  "56:78": 537,
  "56:79": 537,
  "56:80": 537,
  "56:81": 537,
  "56:82": 537,
  "56:83": 537,
  "56:84": 537,
  "56:85": 537,
  "56:86": 537,
  "56:87": 537,
  "56:88": 537,
  "56:89": 537,
  "56:90": 537,
  "56:91": 537,
  "56:92": 537,
  "56:93": 537,
  "56:94": 537,
  "56:95": 537,
  "56:96": 537,
  "57:1": 537,
  "57:2": 537,
  "57:3": 537,
  "57:4": 538,
  "57:5": 538,
  "57:6": 538,
  "57:7": 538,
  "57:8": 538,
  "57:9": 538,
  "57:10": 538,
  "57:11": 538,
  "57:12": 539,
  "57:13": 539,
  "57:14": 539,
  "57:15": 539,
  "57:16": 539,
  "57:17": 539,
  "57:18": 539,
  "57:19": 540,
  "57:20": 540,
  "57:21": 540,
  "57:22": 540,
  "57:23": 540,
  "57:24": 540,
  "57:25": 541,
  "57:26": 541,
  "57:27": 541,
  "57:28": 541,
  "57:29": 541,
  "58:1": 542,
  "58:2": 542,
  "58:3": 542,
  "58:4": 542,
  "58:5": 542,
  "58:6": 542,
  "58:7": 543,
  "58:8": 543,
  "58:9": 543,
  "58:10": 543,
  "58:11": 543,
  "58:12": 544,
  "58:13": 544,
  "58:14": 544,
  "58:15": 544,
  "58:16": 544,
  "58:17": 544,
  "58:18": 544,
  "58:19": 544,
  "58:20": 544,
  "58:21": 544,
  "58:22": 545,
  "59:1": 545,
  "59:2": 545,
  "59:3": 545,
  "59:4": 546,
  "59:5": 546,
  "59:6": 546,
  "59:7": 546,
  "59:8": 546,
  "59:9": 546,
  "59:10": 547,
  "59:11": 547,
  "59:12": 547,
  "59:13": 547,
  "59:14": 547,
  "59:15": 547,
  "59:16": 547,
  "59:17": 548,
  "59:18": 548,
  "59:19": 548,
  "59:20": 548,
  "59:21": 548,
  "59:22": 548,
  "59:23": 548,
  "59:24": 548,
  "60:1": 549,
  "60:2": 549,
  "60:3": 549,
  "60:4": 549,
  "60:5": 549,
  "60:6": 550,
  "60:7": 550,
  "60:8": 550,
  "60:9": 550,
  "60:10": 550,
  "60:11": 550,
  "60:12": 551,
  "60:13": 551,
  "61:1": 551,
  "61:2": 551,
  "61:3": 551,
  "61:4": 551,
  "61:5": 551,
  "61:6": 552,
  "61:7": 552,
  "61:8": 552,
  "61:9": 552,
  "61:10": 552,
  "61:11": 552,
  "61:12": 552,
  "61:13": 552,
  "61:14": 552,
  "62:1": 553,
  "62:2": 553,
  "62:3": 553,
  "62:4": 553,
  "62:5": 553,
  "62:6": 553,
  "62:7": 553,
  "62:8": 553,
  "62:9": 554,
  "62:10": 554,
  "62:11": 554,
  "63:1": 554,
  "63:2": 554,
  "63:3": 554,
  "63:4": 554,
  "63:5": 555,
  "63:6": 555,
  "63:7": 555,
  "63:8": 555,
  "63:9": 555,
  "63:10": 555,
  "63:11": 555,
  "64:1": 556,
  "64:2": 556,
  "64:3": 556,
  "64:4": 556,
  "64:5": 556,
  "64:6": 556,
  "64:7": 556,
  "64:8": 556,
  "64:9": 556,
  "64:10": 557,
  "64:11": 557,
  "64:12": 557,
  "64:13": 557,
  "64:14": 557,
  "64:15": 557,
  "64:16": 557,
  "64:17": 557,
  "64:18": 557,
  "65:1": 558,
  "65:2": 558,
  "65:3": 558,
  "65:4": 558,
  "65:5": 558,
  "65:6": 559,
  "65:7": 559,
  "65:8": 559,
  "65:9": 559,
  "65:10": 559,
  "65:11": 559,
  "65:12": 559,
  "66:1": 560,
  "66:2": 560,
  "66:3": 560,
  "66:4": 560,
  "66:5": 560,
  "66:6": 560,
  "66:7": 560,
  "66:8": 561,
  "66:9": 561,
  "66:10": 561,
  "66:11": 561,
  "66:12": 561,
  "67:1": 562,
  "67:2": 562,
  "67:3": 562,
  "67:4": 562,
  "67:5": 562,
  "67:6": 562,
  "67:7": 562,
  "67:8": 562,
  "67:9": 562,
  "67:10": 562,
  "67:11": 562,
  "67:12": 562,
  "67:13": 563,
  "67:14": 563,
  "67:15": 563,
  "67:16": 563,
  "67:17": 563,
  "67:18": 563,
  "67:19": 563,
  "67:20": 563,
  "67:21": 563,
  "67:22": 563,
  "67:23": 563,
  "67:24": 563,
  "67:25": 563,
  "67:26": 563,
  "67:27": 564,
  "67:28": 564,
  "67:29": 564,
  "67:30": 564,
  "68:1": 564,
  "68:2": 564,
  "68:3": 564,
  "68:4": 564,
  "68:5": 564,
  "68:6": 564,
  "68:7": 564,
  "68:8": 564,
  "68:9": 564,
  "68:10": 564,
  "68:11": 564,
  "68:12": 564,
  "68:13": 564,
  "68:14": 564,
  "68:15": 564,
  "68:16": 565,
  "68:17": 565,
  "68:18": 565,
  "68:19": 565,
  "68:20": 565,
  "68:21": 565,
  "68:22": 565,
  "68:23": 565,
  "68:24": 565,
  "68:25": 565,
  "68:26": 565,
  "68:27": 565,
  "68:28": 565,
  "68:29": 565,
  "68:30": 565,
  "68:31": 565,
  "68:32": 565,
  "68:33": 565,
  "68:34": 565,
  "68:35": 565,
  "68:36": 565,
  "68:37": 565,
  "68:38": 565,
  "68:39": 565,
  "68:40": 565,
  "68:41": 565,
  "68:42": 565,
  "68:43": 566,
  "68:44": 566,
  "68:45": 566,
  "68:46": 566,
  "68:47": 566,
  "68:48": 566,
  "68:49": 566,
  "68:50": 566,
  "68:51": 566,
  "68:52": 566,
  "69:1": 566,
  "69:2": 566,
  "69:3": 566,
  "69:4": 566,
  "69:5": 566,
  "69:6": 566,
  "69:7": 566,
  "69:8": 566,
  "69:9": 567,
  "69:10": 567,
  "69:11": 567,
  "69:12": 567,
  "69:13": 567,
  "69:14": 567,
  "69:15": 567,
  "69:16": 567,
  "69:17": 567,
  "69:18": 567,
  "69:19": 567,
  "69:20": 567,
  "69:21": 567,
  "69:22": 567,
  "69:23": 567,
  "69:24": 567,
  "69:25": 567,
  "69:26": 567,
  "69:27": 567,
  "69:28": 567,
  "69:29": 567,
  "69:30": 567,
  "69:31": 567,
  "69:32": 567,
  "69:33": 567,
  "69:34": 567,
  "69:35": 568,
  "69:36": 568,
  "69:37": 568,
  "69:38": 568,
  "69:39": 568,
  "69:40": 568,
  "69:41": 568,
  "69:42": 568,
  "69:43": 568,
  "69:44": 568,
  "69:45": 568,
  "69:46": 568,
  "69:47": 568,
  "69:48": 568,
  "69:49": 568,
  "69:50": 568,
  "69:51": 568,
  "69:52": 568,
  "70:1": 568,
  "70:2": 568,
  "70:3": 568,
  "70:4": 568,
  "70:5": 568,
  "70:6": 568,
  "70:7": 568,
  "70:8": 568,
  "70:9": 568,
  "70:10": 568,
  "70:11": 569,
  "70:12": 569,
  "70:13": 569,
  "70:14": 569,
  "70:15": 569,
  "70:16": 569,
  "70:17": 569,
  "70:18": 569,
  "70:19": 569,
  "70:20": 569,
  "70:21": 569,
  "70:22": 569,
  "70:23": 569,
  "70:24": 569,
  "70:25": 569,
  "70:26": 569,
  "70:27": 569,
  "70:28": 569,
  "70:29": 569,
  "70:30": 569,
  "70:31": 569,
  "70:32": 569,
  "70:33": 569,
  "70:34": 569,
  "70:35": 569,
  "70:36": 569,
  "70:37": 569,
  "70:38": 569,
  "70:39": 569,
  "70:40": 570,
  "70:41": 570,
  "70:42": 570,
  "70:43": 570,
  "70:44": 570,
  "71:1": 570,
  "71:2": 570,
  "71:3": 570,
  "71:4": 570,
  "71:5": 570,
  "71:6": 570,
  "71:7": 570,
  "71:8": 570,
  "71:9": 570,
  "71:10": 570,
  "71:11": 571,
  "71:12": 571,
  "71:13": 571,
  "71:14": 571,
  "71:15": 571,
  "71:16": 571,
  "71:17": 571,
  "71:18": 571,
  "71:19": 571,
  "71:20": 571,
  "71:21": 571,
  "71:22": 571,
  "71:23": 571,
  "71:24": 571,
  "71:25": 571,
  "71:26": 571,
  "71:27": 571,
  "71:28": 571,
  "72:1": 572,
  "72:2": 572,
  "72:3": 572,
  "72:4": 572,
  "72:5": 572,
  "72:6": 572,
  "72:7": 572,
  "72:8": 572,
  "72:9": 572,
  "72:10": 572,
  "72:11": 572,
  "72:12": 572,
  "72:13": 572,
  "72:14": 573,
  "72:15": 573,
  "72:16": 573,
  "72:17": 573,
  "72:18": 573,
  "72:19": 573,
  "72:20": 573,
  "72:21": 573,
  "72:22": 573,
  "72:23": 573,
  "72:24": 573,
  "72:25": 573,
  "72:26": 573,
  "72:27": 573,
  "72:28": 573,
  "73:1": 574,
  "73:2": 574,
  "73:3": 574,
  "73:4": 574,
  "73:5": 574,
  "73:6": 574,
  "73:7": 574,
  "73:8": 574,
  "73:9": 574,
  "73:10": 574,
  "73:11": 574,
  "73:12": 574,
  "73:13": 574,
  "73:14": 574,
  "73:15": 574,
  "73:16": 574,
  "73:17": 574,
  "73:18": 574,
  "73:19": 574,
  "73:20": 575,
  "74:1": 575,
  "74:2": 575,
  "74:3": 575,
  "74:4": 575,
  "74:5": 575,
  "74:6": 575,
  "74:7": 575,
  "74:8": 575,
  "74:9": 575,
  "74:10": 575,
  "74:11": 575,
  "74:12": 575,
  "74:13": 575,
  "74:14": 575,
  "74:15": 575,
  "74:16": 575,
  "74:17": 575,
  "74:18": 576,
  "74:19": 576,
  "74:20": 576,
  "74:21": 576,
  "74:22": 576,
  "74:23": 576,
  "74:24": 576,
  "74:25": 576,
  "74:26": 576,
  "74:27": 576,
  "74:28": 576,
  "74:29": 576,
  "74:30": 576,
  "74:31": 576,
  "74:32": 576,
  "74:33": 576,
  "74:34": 576,
  "74:35": 576,
  "74:36": 576,
  "74:37": 576,
  "74:38": 576,
  "74:39": 576,
  "74:40": 576,
  "74:41": 576,
  "74:42": 576,
  "74:43": 576,
  "74:44": 576,
  "74:45": 576,
  "74:46": 576,
  "74:47": 576,
  "74:48": 577,
  "74:49": 577,
  "74:50": 577,
  "74:51": 577,
  "74:52": 577,
  "74:53": 577,
  "74:54": 577,
  "74:55": 577,
  "74:56": 577,
  "75:1": 577,
  "75:2": 577,
  "75:3": 577,
  "75:4": 577,
  "75:5": 577,
  "75:6": 577,
  "75:7": 577,
  "75:8": 577,
  "75:9": 577,
  "75:10": 577,
  "75:11": 577,
  "75:12": 577,
  "75:13": 577,
  "75:14": 577,
  "75:15": 577,
  "75:16": 577,
  "75:17": 577,
  "75:18": 577,
  "75:19": 577,
  "75:20": 578,
  "75:21": 578,
  "75:22": 578,
  "75:23": 578,
  "75:24": 578,
  "75:25": 578,
  "75:26": 578,
  "75:27": 578,
  "75:28": 578,
  "75:29": 578,
  "75:30": 578,
  "75:31": 578,
  "75:32": 578,
  "75:33": 578,
  "75:34": 578,
  "75:35": 578,
  "75:36": 578,
  "75:37": 578,
  "75:38": 578,
  "75:39": 578,
  "75:40": 578,
  "76:1": 578,
  "76:2": 578,
  "76:3": 578,
  "76:4": 578,
  "76:5": 578,
  "76:6": 579,
  "76:7": 579,
  "76:8": 579,
  "76:9": 579,
  "76:10": 579,
  "76:11": 579,
  "76:12": 579,
  "76:13": 579,
  "76:14": 579,
  "76:15": 579,
  "76:16": 579,
  "76:17": 579,
  "76:18": 579,
  "76:19": 579,
  "76:20": 579,
  "76:21": 579,
  "76:22": 579,
  "76:23": 579,
  "76:24": 579,
  "76:25": 579,
  "76:26": 580,
  "76:27": 580,
  "76:28": 580,
  "76:29": 580,
  "76:30": 580,
  "76:31": 580,
  "77:1": 580,
  "77:2": 580,
  "77:3": 580,
  "77:4": 580,
  "77:5": 580,
  "77:6": 580,
  "77:7": 580,
  "77:8": 580,
  "77:9": 580,
  "77:10": 580,
  "77:11": 580,
  "77:12": 580,
  "77:13": 580,
  "77:14": 580,
  "77:15": 580,
  "77:16": 580,
  "77:17": 580,
  "77:18": 580,
  "77:19": 580,
  "77:20": 581,
  "77:21": 581,
  "77:22": 581,
  "77:23": 581,
  "77:24": 581,
  "77:25": 581,
  "77:26": 581,
  "77:27": 581,
  "77:28": 581,
  "77:29": 581,
  "77:30": 581,
  "77:31": 581,
  "77:32": 581,
  "77:33": 581,
  "77:34": 581,
  "77:35": 581,
  "77:36": 581,
  "77:37": 581,
  "77:38": 581,
  "77:39": 581,
  "77:40": 581,
  "77:41": 581,
  "77:42": 581,
  "77:43": 581,
  "77:44": 581,
  "77:45": 581,
  "77:46": 581,
  "77:47": 581,
  "77:48": 581,
  "77:49": 581,
  "77:50": 581,
  "78:1": 582,
  "78:2": 582,
  "78:3": 582,
  "78:4": 582,
  "78:5": 582,
  "78:6": 582,
  "78:7": 582,
  "78:8": 582,
  "78:9": 582,
  "78:10": 582,
  "78:11": 582,
  "78:12": 582,
  "78:13": 582,
  "78:14": 582,
  "78:15": 582,
  "78:16": 582,
  "78:17": 582,
  "78:18": 582,
  "78:19": 582,
  "78:20": 582,
  "78:21": 582,
  "78:22": 582,
  "78:23": 582,
  "78:24": 582,
  "78:25": 582,
  "78:26": 582,
  "78:27": 582,
  "78:28": 582,
  "78:29": 582,
  "78:30": 582,
  "78:31": 583,
  "78:32": 583,
  "78:33": 583,
  "78:34": 583,
  "78:35": 583,
  "78:36": 583,
  "78:37": 583,
  "78:38": 583,
  "78:39": 583,
  "78:40": 583,
  "79:1": 583,
  "79:2": 583,
  "79:3": 583,
  "79:4": 583,
  "79:5": 583,
  "79:6": 583,
  "79:7": 583,
  "79:8": 583,
  "79:9": 583,
  "79:10": 583,
  "79:11": 583,
  "79:12": 583,
  "79:13": 583,
  "79:14": 583,
  "79:15": 583,
  "79:16": 584,
  "79:17": 584,
  "79:18": 584,
  "79:19": 584,
  "79:20": 584,
  "79:21": 584,
  "79:22": 584,
  "79:23": 584,
  "79:24": 584,
  "79:25": 584,
  "79:26": 584,
  "79:27": 584,
  "79:28": 584,
  "79:29": 584,
  "79:30": 584,
  "79:31": 584,
  "79:32": 584,
  "79:33": 584,
  "79:34": 584,
  "79:35": 584,
  "79:36": 584,
  "79:37": 584,
  "79:38": 584,
  "79:39": 584,
  "79:40": 584,
  "79:41": 584,
  "79:42": 584,
  "79:43": 584,
  "79:44": 584,
  "79:45": 584,
  "79:46": 584,
  "80:1": 585,
  "80:2": 585,
  "80:3": 585,
  "80:4": 585,
  "80:5": 585,
  "80:6": 585,
  "80:7": 585,
  "80:8": 585,
  "80:9": 585,
  "80:10": 585,
  "80:11": 585,
  "80:12": 585,
  "80:13": 585,
  "80:14": 585,
  "80:15": 585,
  "80:16": 585,
  "80:17": 585,
  "80:18": 585,
  "80:19": 585,
  "80:20": 585,
  "80:21": 585,
  "80:22": 585,
  "80:23": 585,
  "80:24": 585,
  "80:25": 585,
  "80:26": 585,
  "80:27": 585,
  "80:28": 585,
  "80:29": 585,
  "80:30": 585,
  "80:31": 585,
  "80:32": 585,
  "80:33": 585,
  "80:34": 585,
  "80:35": 585,
  "80:36": 585,
  "80:37": 585,
  "80:38": 585,
  "80:39": 585,
  "80:40": 585,
  "80:41": 585,
  "80:42": 585,
  "81:1": 586,
  "81:2": 586,
  "81:3": 586,
  "81:4": 586,
  "81:5": 586,
  "81:6": 586,
  "81:7": 586,
  "81:8": 586,
  "81:9": 586,
  "81:10": 586,
  "81:11": 586,
  "81:12": 586,
  "81:13": 586,
  "81:14": 586,
  "81:15": 586,
  "81:16": 586,
  "81:17": 586,
  "81:18": 586,
  "81:19": 586,
  "81:20": 586,
  "81:21": 586,
  "81:22": 586,
  "81:23": 586,
  "81:24": 586,
  "81:25": 586,
  "81:26": 586,
  "81:27": 586,
  "81:28": 586,
  "81:29": 586,
  "82:1": 587,
  "82:2": 587,
  "82:3": 587,
  "82:4": 587,
  "82:5": 587,
  "82:6": 587,
  "82:7": 587,
  "82:8": 587,
  "82:9": 587,
  "82:10": 587,
  "82:11": 587,
  "82:12": 587,
  "82:13": 587,
  "82:14": 587,
  "82:15": 587,
  "82:16": 587,
  "82:17": 587,
  "82:18": 587,
  "82:19": 587,
  "83:1": 587,
  "83:2": 587,
  "83:3": 587,
  "83:4": 587,
  "83:5": 587,
  "83:6": 587,
  "83:7": 588,
  "83:8": 588,
  "83:9": 588,
  "83:10": 588,
  "83:11": 588,
  "83:12": 588,
  "83:13": 588,
  "83:14": 588,
  "83:15": 588,
  "83:16": 588,
  "83:17": 588,
  "83:18": 588,
  "83:19": 588,
  "83:20": 588,
  "83:21": 588,
  "83:22": 588,
  "83:23": 588,
  "83:24": 588,
  "83:25": 588,
  "83:26": 588,
  "83:27": 588,
  "83:28": 588,
  "83:29": 588,
  "83:30": 588,
  "83:31": 588,
  "83:32": 588,
  "83:33": 588,
  "83:34": 588,
  "83:35": 589,
  "83:36": 589,
  "84:1": 589,
  "84:2": 589,
  "84:3": 589,
  "84:4": 589,
  "84:5": 589,
  "84:6": 589,
  "84:7": 589,
  "84:8": 589,
  "84:9": 589,
  "84:10": 589,
  "84:11": 589,
  "84:12": 589,
  "84:13": 589,
  "84:14": 589,
  "84:15": 589,
  "84:16": 589,
  "84:17": 589,
  "84:18": 589,
  "84:19": 589,
  "84:20": 589,
  "84:21": 589,
  "84:22": 589,
  "84:23": 589,
  "84:24": 589,
  "84:25": 589,
  "85:1": 590,
  "85:2": 590,
  "85:3": 590,
  "85:4": 590,
  "85:5": 590,
  "85:6": 590,
  "85:7": 590,
  "85:8": 590,
  "85:9": 590,
  "85:10": 590,
  "85:11": 590,
  "85:12": 590,
  "85:13": 590,
  "85:14": 590,
  "85:15": 590,
  "85:16": 590,
  "85:17": 590,
  "85:18": 590,
  "85:19": 590,
  "85:20": 590,
  "85:21": 590,
  "85:22": 590,
  "86:1": 591,
  "86:2": 591,
  "86:3": 591,
  "86:4": 591,
  "86:5": 591,
  "86:6": 591,
  "86:7": 591,
  "86:8": 591,
  "86:9": 591,
  "86:10": 591,
  "86:11": 591,
  "86:12": 591,
  "86:13": 591,
  "86:14": 591,
  "86:15": 591,
  "86:16": 591,
  "86:17": 591,
  "87:1": 591,
  "87:2": 591,
  "87:3": 591,
  "87:4": 591,
  "87:5": 591,
  "87:6": 591,
  "87:7": 591,
  "87:8": 591,
  "87:9": 591,
  "87:10": 591,
  "87:11": 591,
  "87:12": 591,
  "87:13": 591,
  "87:14": 591,
  "87:15": 591,
  "87:16": 592,
  "87:17": 592,
  "87:18": 592,
  "87:19": 592,
  "88:1": 592,
  "88:2": 592,
  "88:3": 592,
  "88:4": 592,
  "88:5": 592,
  "88:6": 592,
  "88:7": 592,
  "88:8": 592,
  "88:9": 592,
  "88:10": 592,
  "88:11": 592,
  "88:12": 592,
  "88:13": 592,
  "88:14": 592,
  "88:15": 592,
  "88:16": 592,
  "88:17": 592,
  "88:18": 592,
  "88:19": 592,
  "88:20": 592,
  "88:21": 592,
  "88:22": 592,
  "88:23": 592,
  "88:24": 592,
  "88:25": 592,
  "88:26": 592,
  "89:1": 593,
  "89:2": 593,
  "89:3": 593,
  "89:4": 593,
  "89:5": 593,
  "89:6": 593,
  "89:7": 593,
  "89:8": 593,
  "89:9": 593,
  "89:10": 593,
  "89:11": 593,
  "89:12": 593,
  "89:13": 593,
  "89:14": 593,
  "89:15": 593,
  "89:16": 593,
  "89:17": 593,
  "89:18": 593,
  "89:19": 593,
  "89:20": 593,
  "89:21": 593,
  "89:22": 593,
  "89:23": 593,
  "89:24": 594,
  "89:25": 594,
  "89:26": 594,
  "89:27": 594,
  "89:28": 594,
  "89:29": 594,
  "89:30": 594,
  "90:1": 594,
  "90:2": 594,
  "90:3": 594,
  "90:4": 594,
  "90:5": 594,
  "90:6": 594,
  "90:7": 594,
  "90:8": 594,
  "90:9": 594,
  "90:10": 594,
  "90:11": 594,
  "90:12": 594,
  "90:13": 594,
  "90:14": 594,
  "90:15": 594,
  "90:16": 594,
  "90:17": 594,
  "90:18": 594,
  "90:19": 594,
  "90:20": 594,
  "91:1": 595,
  "91:2": 595,
  "91:3": 595,
  "91:4": 595,
  "91:5": 595,
  "91:6": 595,
  "91:7": 595,
  "91:8": 595,
  "91:9": 595,
  "91:10": 595,
  "91:11": 595,
  "91:12": 595,
  "91:13": 595,
  "91:14": 595,
  "91:15": 595,
  "92:1": 595,
  "92:2": 595,
  "92:3": 595,
  "92:4": 595,
  "92:5": 595,
  "92:6": 595,
  "92:7": 595,
  "92:8": 595,
  "92:9": 595,
  "92:10": 595,
  "92:11": 595,
  "92:12": 595,
  "92:13": 595,
  "92:14": 595,
  "92:15": 596,
  "92:16": 596,
  "92:17": 596,
  "92:18": 596,
  "92:19": 596,
  "92:20": 596,
  "92:21": 596,
  "93:1": 596,
  "93:2": 596,
  "93:3": 596,
  "93:4": 596,
  "93:5": 596,
  "93:6": 596,
  "93:7": 596,
  "93:8": 596,
  "93:9": 596,
  "93:10": 596,
  "93:11": 596,
  "94:1": 596,
  "94:2": 596,
  "94:3": 596,
  "94:4": 596,
  "94:5": 596,
  "94:6": 596,
  "94:7": 596,
  "94:8": 596,
  "95:1": 597,
  "95:2": 597,
  "95:3": 597,
  "95:4": 597,
  "95:5": 597,
  "95:6": 597,
  "95:7": 597,
  "95:8": 597,
  "96:1": 597,
  "96:2": 597,
  "96:3": 597,
  "96:4": 597,
  "96:5": 597,
  "96:6": 597,
  "96:7": 597,
  "96:8": 597,
  "96:9": 597,
  "96:10": 597,
  "96:11": 597,
  "96:12": 597,
  "96:13": 597,
  "96:14": 597,
  "96:15": 597,
  "96:16": 597,
  "96:17": 597,
  "96:18": 597,
  "96:19": 597,
  "97:1": 598,
  "97:2": 598,
  "97:3": 598,
  "97:4": 598,
  "97:5": 598,
  "98:1": 598,
  "98:2": 598,
  "98:3": 598,
  "98:4": 598,
  "98:5": 598,
  "98:6": 598,
  "98:7": 598,
  "98:8": 599,
  "99:1": 599,
  "99:2": 599,
  "99:3": 599,
  "99:4": 599,
  "99:5": 599,
  "99:6": 599,
  "99:7": 599,
  "99:8": 599,
  "100:1": 599,
  "100:2": 599,
  "100:3": 599,
  "100:4": 599,
  "100:5": 599,
  "100:6": 599,
  "100:7": 599,
  "100:8": 599,
  "100:9": 599,
  "100:10": 600,
  "100:11": 600,
  "101:1": 600,
  "101:2": 600,
  "101:3": 600,
  "101:4": 600,
  "101:5": 600,
  "101:6": 600,
  "101:7": 600,
  "101:8": 600,
  "101:9": 600,
  "101:10": 600,
  "101:11": 600,
  "102:1": 600,
  "102:2": 600,
  "102:3": 600,
  "102:4": 600,
  "102:5": 600,
  "102:6": 600,
  "102:7": 600,
  "102:8": 600,
  "103:1": 601,
  "103:2": 601,
  "103:3": 601,
  "104:1": 601,
  "104:2": 601,
  "104:3": 601,
  "104:4": 601,
  "104:5": 601,
  "104:6": 601,
  "104:7": 601,
  "104:8": 601,
  "104:9": 601,
  "105:1": 601,
  "105:2": 601,
  "105:3": 601,
  "105:4": 601,
  "105:5": 601,
  "106:1": 602,
  "106:2": 602,
  "106:3": 602,
  "106:4": 602,
  "107:1": 602,
  "107:2": 602,
  "107:3": 602,
  "107:4": 602,
  "107:5": 602,
  "107:6": 602,
  "107:7": 602,
  "108:1": 602,
  "108:2": 602,
  "108:3": 602,
  "109:1": 603,
  "109:2": 603,
  "109:3": 603,
  "109:4": 603,
  "109:5": 603,
  "109:6": 603,
  "110:1": 603,
  "110:2": 603,
  "110:3": 603,
  "111:1": 603,
  "111:2": 603,
  "111:3": 603,
  "111:4": 603,
  "111:5": 603,
  "112:1": 604,
  "112:2": 604,
  "112:3": 604,
  "112:4": 604,
  "113:1": 604,
  "113:2": 604,
  "113:3": 604,
  "113:4": 604,
  "113:5": 604,
  "114:1": 604,
  "114:2": 604,
  "114:3": 604,
  "114:4": 604,
  "114:5": 604,
  "114:6": 604
}

export const surahPageRanges = {
  1: { startPage: 1, endPage: 1 },
  2: { startPage: 2, endPage: 49 },
  3: { startPage: 50, endPage: 76 },
  4: { startPage: 77, endPage: 106 },
  5: { startPage: 106, endPage: 127 },
  6: { startPage: 128, endPage: 150 },
  7: { startPage: 151, endPage: 176 },
  8: { startPage: 177, endPage: 186 },
  9: { startPage: 187, endPage: 207 },
  10: { startPage: 208, endPage: 221 },
  11: { startPage: 221, endPage: 235 },
  12: { startPage: 235, endPage: 248 },
  13: { startPage: 249, endPage: 255 },
  14: { startPage: 255, endPage: 261 },
  15: { startPage: 262, endPage: 267 },
  16: { startPage: 267, endPage: 281 },
  17: { startPage: 282, endPage: 293 },
  18: { startPage: 293, endPage: 304 },
  19: { startPage: 305, endPage: 312 },
  20: { startPage: 312, endPage: 321 },
  21: { startPage: 322, endPage: 331 },
  22: { startPage: 332, endPage: 341 },
  23: { startPage: 342, endPage: 349 },
  24: { startPage: 350, endPage: 359 },
  25: { startPage: 359, endPage: 366 },
  26: { startPage: 367, endPage: 376 },
  27: { startPage: 377, endPage: 385 },
  28: { startPage: 385, endPage: 396 },
  29: { startPage: 396, endPage: 404 },
  30: { startPage: 404, endPage: 410 },
  31: { startPage: 411, endPage: 414 },
  32: { startPage: 415, endPage: 417 },
  33: { startPage: 418, endPage: 427 },
  34: { startPage: 428, endPage: 434 },
  35: { startPage: 434, endPage: 440 },
  36: { startPage: 440, endPage: 445 },
  37: { startPage: 446, endPage: 452 },
  38: { startPage: 453, endPage: 458 },
  39: { startPage: 458, endPage: 467 },
  40: { startPage: 467, endPage: 476 },
  41: { startPage: 477, endPage: 482 },
  42: { startPage: 483, endPage: 489 },
  43: { startPage: 489, endPage: 495 },
  44: { startPage: 496, endPage: 498 },
  45: { startPage: 499, endPage: 502 },
  46: { startPage: 502, endPage: 506 },
  47: { startPage: 507, endPage: 510 },
  48: { startPage: 511, endPage: 515 },
  49: { startPage: 515, endPage: 517 },
  50: { startPage: 518, endPage: 520 },
  51: { startPage: 520, endPage: 523 },
  52: { startPage: 523, endPage: 525 },
  53: { startPage: 526, endPage: 528 },
  54: { startPage: 528, endPage: 531 },
  55: { startPage: 531, endPage: 534 },
  56: { startPage: 534, endPage: 537 },
  57: { startPage: 537, endPage: 541 },
  58: { startPage: 542, endPage: 545 },
  59: { startPage: 545, endPage: 548 },
  60: { startPage: 549, endPage: 551 },
  61: { startPage: 551, endPage: 552 },
  62: { startPage: 553, endPage: 554 },
  63: { startPage: 554, endPage: 555 },
  64: { startPage: 556, endPage: 557 },
  65: { startPage: 558, endPage: 559 },
  66: { startPage: 560, endPage: 561 },
  67: { startPage: 562, endPage: 564 },
  68: { startPage: 564, endPage: 566 },
  69: { startPage: 566, endPage: 568 },
  70: { startPage: 568, endPage: 570 },
  71: { startPage: 570, endPage: 571 },
  72: { startPage: 572, endPage: 573 },
  73: { startPage: 574, endPage: 575 },
  74: { startPage: 575, endPage: 577 },
  75: { startPage: 577, endPage: 578 },
  76: { startPage: 578, endPage: 580 },
  77: { startPage: 580, endPage: 581 },
  78: { startPage: 582, endPage: 583 },
  79: { startPage: 583, endPage: 584 },
  80: { startPage: 585, endPage: 585 },
  81: { startPage: 586, endPage: 586 },
  82: { startPage: 587, endPage: 587 },
  83: { startPage: 587, endPage: 589 },
  84: { startPage: 589, endPage: 589 },
  85: { startPage: 590, endPage: 590 },
  86: { startPage: 591, endPage: 591 },
  87: { startPage: 591, endPage: 592 },
  88: { startPage: 592, endPage: 592 },
  89: { startPage: 593, endPage: 594 },
  90: { startPage: 594, endPage: 594 },
  91: { startPage: 595, endPage: 595 },
  92: { startPage: 595, endPage: 596 },
  93: { startPage: 596, endPage: 596 },
  94: { startPage: 596, endPage: 596 },
  95: { startPage: 597, endPage: 597 },
  96: { startPage: 597, endPage: 597 },
  97: { startPage: 598, endPage: 598 },
  98: { startPage: 598, endPage: 599 },
  99: { startPage: 599, endPage: 599 },
  100: { startPage: 599, endPage: 600 },
  101: { startPage: 600, endPage: 600 },
  102: { startPage: 600, endPage: 600 },
  103: { startPage: 601, endPage: 601 },
  104: { startPage: 601, endPage: 601 },
  105: { startPage: 601, endPage: 601 },
  106: { startPage: 602, endPage: 602 },
  107: { startPage: 602, endPage: 602 },
  108: { startPage: 602, endPage: 602 },
  109: { startPage: 603, endPage: 603 },
  110: { startPage: 603, endPage: 603 },
  111: { startPage: 603, endPage: 603 },
  112: { startPage: 604, endPage: 604 },
  113: { startPage: 604, endPage: 604 },
  114: { startPage: 604, endPage: 604 }
}
